<template>
  <div class="sign" :style="{ minHeight: pageHeight + 'px' }">
    <!-- 进步 -->
    <div class="sign-step">
      <van-steps
        :active="stepActive"
        active-icon="success"
        active-color="#00D385"
      >
        <van-step>填写信息</van-step>
        <!-- <van-step>确定信息</van-step> -->
        <van-step>支付并完成</van-step>
      </van-steps>
    </div>

    <div class="step1" v-show="stepActive == 0">
      <!-- 保险信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">保险信息</div>
        </div>

        <div class="inp-box">
          <div class="item">
            <van-field
              label="保险名称:"
              v-model.trim="step1Data.name"
              readonly
            />
          </div>
          <div class="item">
            <van-field
              label="保险计划:"
              value="请选择保险计划"
              v-model.trim="step1Data.planName"
              @click="chosePlanFlag = true"
              readonly
              right-icon="arrow-down"
            />
          </div>
          <div class="item">
            <van-field
              label="承保年龄:"
              value="请选择保险计划"
              v-model.trim="step1Data.planAge"
              readonly
            />
          </div>
          <div class="item" v-if="!detail.hasDestnation">
            <van-field
              disabled
              v-model.trim="step1Data.planAddr"
              label="目的地"
              placeholder="请输入目的地"
            />
          </div>
          <div
            class="item"
            @click="openSelectAddr()"
            v-if="detail.hasDestnation"
          >
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>目的地:</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div
                  class="van-field__body"
                  style="text-align: left; display: grid"
                >
                  <span
                    v-if="step1Data.planAddr"
                    style="font-size: 0.1rem; text-align: left; color: #323233"
                    >{{ step1Data.planAddr }}</span
                  >
                  <span
                    v-else
                    style="font-size: 0.1rem; text-align: left; color: red"
                    >请选择目的地!</span
                  >
                  <div
                    style="position: absolute; right: 0"
                    class="van-field__right-icon"
                  >
                    <i class="van-icon van-icon-arrow-down"><!----></i>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- <div class="item">
            <van-field label="起始时间:" value="请选择保障起始时间" v-model.trim="step1Data.startTime" readonly />
          </div>
          <div class="item">
            <van-field label="终止时间:" value="请选择保障终止时间" v-model.trim="step1Data.endTime" readonly />
          </div>-->
          <div class="item">
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>保期:</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div
                  class="van-field__body"
                  style="color: #323233; text-align: left; font-size: 0.11rem"
                >
                  {{ step1Data.startTime }} - {{ step1Data.endTime }}
                </div>
              </div>
            </div>
            <!-- <div class="van-field__value label">保期:</div>
            <div class="van-field__value text">
              {{step1Data.startTime}} - {{step1Data.endTime}}
            </div>-->
            <!-- <van-field label="终止时间:" value="请选择保障终止时间" v-model.trim="step1Data.endTime" readonly /> -->
          </div>
          <div class="item">
            <div class="van-cell van-field">
              <div class="van-cell__title van-field__label">
                <span>注意:</span>
              </div>
              <div class="van-cell__value van-field__value">
                <div
                  class="van-field__body"
                  style="text-align: left; display: grid"
                >
                  <span
                    style="font-size: 12px; text-align: left; line-height: 1.2"
                    >起保日期以保险公司出具的保险单正本（或承保确认函）为准，起保日期将不早于您的缴费日期。</span
                  >
                  <span
                    style="
                      color: red;
                      font-size: 12px;
                      text-align: left;
                      line-height: 1.2;
                    "
                    v-if="detail.canTodayBuy"
                    >本产品支持即时生效，若选择当天起保。则以支付后{{
                      todayBuyMin ? todayBuyMin : "1小时"
                    }}作为起保时间。</span
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="bar10px"></div>

      <!-- 投保人信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">投保人信息</div>
        </div>

        <div class="inp-box insurepeopel_box">
          <van-form validate-first @failed="onFailed">
            <div class="item" :class="insureError.name ? 'error' : ''">
              <van-field
                v-if="detail.insuranceCompanyId!==17"
                @blur="blurInsure('name', policyHolder.name, true)"
                required
                v-model="policyHolder.name"
                label="姓名/公司名:"
                placeholder="请输入投保人姓名"
              />
              <van-field
                v-else
                @blur="blurInsure('name', policyHolder.name, true)"
                required
                v-model="policyHolder.name"
                label="姓名:"
                placeholder="请输入投保人姓名"
              />
            </div>
            <div
              v-if="detail.hasPinyin"
              class="item"
              :class="insureError.pinyin ? 'error' : ''"
            >
              <van-field
                @blur="blurInsure('pinyin', policyHolder.pinyin, true)"
                required
                v-model.trim="policyHolder.pinyin"
                label="投保人拼音:"
                placeholder="请输入投保人拼音"
              />
            </div>
            <div class="item">
               <!-- v-if="detail.insuranceCompanyId!==17" -->
              <van-field
                required
                label="证件类型:"
                value="请选择证件类型"
                v-model.trim="policyHolder.idType"
                @click="idTypeFlag = true"
                readonly
                right-icon="arrow-down"
              />
            </div>
            <div class="item" :class="insureError.idCode ? 'error' : ''">
              <van-field
                @blur="blurInsure('idCode', policyHolder.idCode, true)"
                required
                v-model.trim="policyHolder.idCode"
                name="checkIdcode"
                :rules="[{ checkIdcode, message: '请输入正确内容' }]"
                label="证件号码:"
                placeholder="请输入证件号码"
              />
            </div>
            <div class="item">
              <van-field
                required
                label="性别:"
                value="请选择性别"
                v-model.trim="policyHolder.sex"
                @click="sexFlag = true"
                readonly
                right-icon="arrow-down"
              />
            </div>
            <div class="item" v-if="policyHolder.idType != '社会信用代码'" :class="insureError.birthday ? 'error' : ''">
              <van-field
                required
                label="出生日期:"
                value="请选择出生日期"
                v-model.trim="policyHolder.birthDay"
                @click="birthdayFlag = true"
                @blur="blurInsure('birthday', policyHolder.birthDay, true)"
                :min-date="minDate"
                :max-date="maxDate"
                readonly
                placeholder="请选择出生日期"
                right-icon="calender-o"
              />
            </div>
            <div class="item" :class="insureError.phone ? 'error' : ''">
              <van-field
                @blur="blurInsure('phone', policyHolder.phone, true)"
                required
                v-model.trim="policyHolder.phone"
                label="手机号码:"
                placeholder="请输入投保联系方式"
              />
            </div>
            <!-- <div class="item">
              <van-field
                v-model.trim="policyHolder.email"
                label="邮箱:"
                placeholder="请输入投保人邮箱用于接收保单"
              />
            </div> -->
          </van-form>
        </div>
      </div>

      <div class="bar10px"></div>

      <!-- <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">被保人信息</div>
        </div>
        <div class="inp-box">
          <van-radio-group v-model.trim="insuredEditType" direction="horizontal" @change="changeInsuredEditType">
            <van-radio icon-size="12px" :name="1">手动填写</van-radio>
            <van-radio icon-size="12px" :name="2">与投保人相同</van-radio>
          </van-radio-group>
        </div>
      </div> -->

      <!-- <div class="bar10px"></div> -->

      <!-- 被保人信息 -->
      <div class="info">
        <div class="title">
          <div class="px1bar"></div>
          <div class="text">被保人信息</div>
          <div
            class="copy"
            style="
              font-size: 14px;
              margin-left: auto;
              display: flex;
              align-items: center;
            "
            @click="copyFlag = true"
          >
            <img
              src="./assets/images/copy.png"
              style="width: 14px; margin-right: 5px; color: #999"
              alt
            />
            粘贴名单
          </div>
        </div>
        <div class="import-name">
          <div @click="openName()" class="btn">+ 导入已收集名单</div>
        </div>
        <div class="people-list">
          <div
            class="people-item"
            v-for="(item, index) in InsuredList"
            :key="index"
            @click="openInsured('edit', item, index)"
          >
            <div style="font-size:16px;line-height:93px;margin-right:12px;">{{index+1}}</div>
            <div class="left">
               <div class="tip">
                <div class="name">{{ item.name }} <span v-if="detail.hasPinyin">({{ item.pinyin }})</span></div>
                <div class="idcode" v-html="$options.filters.checkIdName(item.name)">
                </div>
              </div>
              <!-- <div class="name">
               {{ item.name }}
                <span v-if="detail.hasPinyin">({{ item.pinyin }})</span>
              </div> -->
              <div class="tip">
                <div class="idtype">{{ item.idType }}</div>
                <div class="idcode" v-html="$options.filters.checkIdCode(item.idCode,item.idType,that)"></div>
              </div>
              <div class="tip">
                <div class="idtype">出生日期</div>
                <div class="idcode">
                  <div
                    v-html="$options.filters.checkBirthday(item.birthday,that)"
                  ></div>
                </div>
              </div>
            </div>
            <div class="right">
              <div class="price">¥{{ oneprice }}</div>
              <van-icon name="arrow" />
              <div
                class="del"
                @click.stop="
                  InsuredList.splice(index, 1);
                  calculateOrder();
                "
              >
                <!-- <van-icon name="delete-o" color="red" size="16px" /> -->
                <span style="color: red; font-size: 12px; font-weight: 900"
                  >删除</span
                >
              </div>
            </div>
          </div>
        </div>
        <div class="add-box" style="display: flex">
          <div class="add-link">
            <van-checkbox
              icon-size="12px"
              v-model.trim="insuredEditFlag"
              @change="changeInsuredEdit"
              >与投保人相同</van-checkbox
            >
          </div>
          <div class="add-link" @click="openInsured('add')">
            <img src="./assets/images/add.png" alt />
            <span>添加被保人</span>
          </div>
        </div>
      </div>
    </div>

    <div class="step2" v-if="stepActive == 1">
      <div class="titel">{{ detail.title }}</div>
      <div class="data-list">
        <van-collapse v-model.trim="activeNames">
          <van-collapse-item name="1" class="collapse-item">
            <template #title>
              <div class="item-name" style="display: flex">
                <div class="px1bar"></div>
                保险明细
              </div>
            </template>
            <div class="item-content">
              <div class="item">
                <div class="label">保险计划：</div>
                <div class="text">{{ step1Data.planName }}</div>
              </div>
              <div class="item">
                <div class="label">保障周期：</div>
                <div class="text">
                  {{ step1Data.startTime }} - {{ step1Data.endTime }}
                </div>
                <!-- <div class="text" v-if="this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].start -= this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].end">
                  {{this.detail.plans[this.$route.query.plan].cycle[this.$route.query.date].start}}
                  天
                </div> -->
              </div>
              <div class="item">
                <div class="label">保障内容：</div>
                <div class="text">
                  <ul class="summary-info">
                    <li
                      v-for="(item, index) in this.detail.plans[
                        this.$route.query.plan
                      ].summarys"
                      :key="index"
                    >
                      <div class="name">{{ item.name }}</div>
                      <div class="price">{{ item.price | countFilter }}元</div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </van-collapse-item>
          <div class="bar10px"></div>
          <van-collapse-item name="2" class="collapse-item">
            <template #title>
              <div class="item-name" style="display: flex">
                <div class="px1bar"></div>
                投保人信息
              </div>
            </template>
            <div class="item-content">
              <div class="item">
                <div class="label">投保人姓名：</div>
                <div class="text">{{ policyHolder.name }}</div>
              </div>
              <div class="item" v-if="detail.hasPinyin">
                <div class="label">投保人拼音：</div>
                <div class="text">{{ policyHolder.pinyin }}</div>
              </div>
              <div class="item">
                <div class="label">证件类型：</div>
                <div class="text">{{ policyHolder.idType }}</div>
              </div>
              <div class="item">
                <div class="label">证件号：</div>
                <div class="text">{{ policyHolder.idCode }}</div>
              </div>
              <div class="item">
                <div class="label">性别：</div>
                <div class="text">{{ policyHolder.sex }}</div>
              </div>
              <div class="item">
                <div class="label">出生日期：</div>
                <div class="text">{{ policyHolder.birthDay }}</div>
              </div>
              <div class="item">
                <div class="label">手机号：</div>
                <div class="text">{{ policyHolder.phone }}</div>
              </div>
              <!-- <div class="item">
                <div class="label">邮箱：</div>
                <div class="text">{{ policyHolder.email }}</div>
              </div> -->
            </div>
          </van-collapse-item>
          <div class="bar10px"></div>
          <van-collapse-item name="3" class="collapse-item">
            <template #title>
              <div class="item-name" style="display: flex">
                <div class="px1bar"></div>
                被保人信息
              </div>
            </template>
            <div class="item-content">
              <div
                class="limargin"
                v-for="(item, index) in InsuredList"
                :key="index"
              >
                <div class="item">
                  <div class="label">被保人姓名：</div>
                  <div class="text">{{ item.name }}</div>
                </div>
                <div class="item" v-if="detail.hasPinyin">
                  <div class="label">被保人拼音：</div>
                  <div class="text">{{ item.pinyin }}</div>
                </div>
                <div class="item">
                  <div class="label">证件类型：</div>
                  <div class="text">{{ item.idType }}</div>
                </div>
                <div class="item">
                  <div class="label">证件号：</div>
                  <div class="text">{{ item.idCode }}</div>
                </div>
                <div class="item">
                  <div class="label">性别：</div>
                  <div class="text">{{ item.sex == 1 ? "男" : "女" }}</div>
                </div>
                <div class="item">
                  <div class="label">出生日期：</div>
                  <div class="text">
                    {{ moment(item.birthday).format("YYYY-MM-DD") }}
                  </div>
                </div>
                <div class="item">
                  <div class="label">手机号：</div>
                  <div class="text">{{ item.phone }}</div>
                </div>
                <!-- <div class="item">
                  <div class="label">邮箱：</div>
                  <div class="text">{{ item.mailbox }}</div>
                </div> -->
              </div>
            </div>
          </van-collapse-item>
        </van-collapse>
      </div>
    </div>

    <div class="tipcheck" style="width: 100%" v-if="stepActive != 0">
      <van-checkbox
        style="width: 100%"
        v-model.trim="subchecked"
        @change="chageReady2"
        checked-color="#07c160"
        shape="square"
        icon-size="16px"
      >
        <div class="text">
          同意
          <b style="color: #1285f7; cursor: pointer">
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              @click.stop="gotoPreview(1)"
              target="_blank"
              >《详细条款与除外责任》</a
            >
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              target="_blank"
              @click.stop="gotoPreview(2)"
              >《投保须知》</a
            >
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              target="_blank"
              @click.stop="
                preview(
                  detail.serviceFiles[0].response.url,
                  detail.serviceFiles[0].name
                )
              "
              >《服务指引》</a
            >
            <a
              style="
                margin: 5px 0;
                font-size: 10px;
                padding-left: 0px;
                font-size: 10px;
                margin-right: 5px;
                color: rgb(18, 133, 247);
              "
              class="a-link"
              target="_blank"
              @click.stop="preview(detail.customerFiles[0].response.url,detail.customerFiles[0].name)"
              >《客户告知书》</a
            >
          </b>
        </div>
      </van-checkbox>
      <van-checkbox
        style="width: 100%"
        @change="chageReady1"
        v-model.trim="isReady1"
        checked-color="#07c160"
        shape="square"
        icon-size="16px"
      >
        <div class="text">
          我已经逐步阅读并同意
          <b style="color: #1285f7; cursor: pointer">
            《免责内容》 《被保险人同意声明》 《投保提示》
          </b>
        </div>
      </van-checkbox>
    </div>
    <div class="foot-btn">
      <div class="left">
        <a href="tel://4008-933-988" v-if="stepActive == 0">
          <img src="./assets/images/tel.png" alt />
        </a>
        <span v-else style="font-weight: 800" @click="stepActive = 0"
          >上一步</span
        >
      </div>
      <div class="price">¥{{ price }}</div>
      <!-- <div v-if="stepActive == 0" style="margin-left:-10px">
        <div class="right" style="float:left;margin-right:2px;height:44px;width:85rpx;color:green;border:1px solid green;background-color:white;font-size:14px;padding:3px" @click="saveOrder()">暂存订单</div>
        <div class="right" style="height:44px;width:82rpx;padding:4px;font-size:14px" @click="changeStep(1)">提交订单</div>
      </div> -->
      <div class="right" v-if="stepActive == 0" style="height:44px;width:82rpx;padding:4px;font-size:14px" @click="changeStep(1)">提交订单</div>
      <div class="right" v-else  @click="prePayOrder()">确认支付</div>
    </div>

    <!-- dialog,popup -->

    <!-- step1的弹框 -->

    <!-- 粘贴 -->
    <van-dialog
      class="copy-text"
      v-model.trim="copyFlag"
      title="粘贴名单"
      show-cancel-button
      @confirm="sendCopyText"
    >
      <div class="box copy_text" style="padding: 20px; box-sizing: border-box">
        <textarea
          style="white-space: pre-line; width: 100%"
          placeholder="请在此处粘贴名单"
          v-model.trim="copyText"
          name
          id
          cols="40"
          rows="10"
        ></textarea>
      </div>
    </van-dialog>

    <div class="step1-dia">
      <van-popup
        v-model.trim="chosePlanFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择计划"
          show-toolbar
          :columns="plans"
          @confirm="onConfirm"
          @cancel="onCancel"
          @change="onChange"
        />
      </van-popup>

      <!-- 投保 -->
      <van-popup
        v-model.trim="idTypeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          v-if="detail.insuranceCompanyId!==17"
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOptions"
          @confirm="onConfirmId"
          @cancel="onCancelId"
          @change="onChangeId"
        />
        <van-picker
          v-else
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOption"
          @confirm="onConfirmId"
          @cancel="onCancelId"
          @change="onChangeId"
        />
      </van-popup>

      <!-- 被保 -->
      <van-popup
        v-model.trim="InsuredIdTypeFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择证件类型"
          show-toolbar
          :columns="idTypeOption"
          @confirm="onConfirmIdInsured"
          @cancel="onCancelIdInsured"
          @change="onChangeIdInsured"
        />
      </van-popup>

      <!-- 投保 -->
      <van-popup
        v-model.trim="sexFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男', '女']"
          @confirm="onConfirmSex"
          @cancel="onCancelSex"
        />
      </van-popup>
      <!-- 被保 -->
      <van-popup
        v-model.trim="InsuredSexFlag"
        round
        position="bottom"
        :style="{ height: '30%' }"
      >
        <van-picker
          title="选择性别"
          show-toolbar
          :columns="['男', '女']"
          @confirm="onConfirmSexInsured"
          @cancel="onCancelSexInsured"
        />
      </van-popup>

      <van-popup
        v-model.trim="InsuredFlag"
        position="bottom"
        :style="{ height: '100%', paddingTop: '30px' }"
        class="Insurededit"
      >
        <div class="item">
          <van-field
            required
            v-model.trim="InsuredModel.name"
            @blur="yanzhengBlur('name',InsuredModel.name)"
            label="被保人姓名:"
            value="请输入投保人姓名"
          />
        </div>
        <div class="item" v-if="detail.hasPinyin">
          <van-field
            required
            @blur="yanzhengBlur('pinyin',InsuredModel.pinyin)"
            v-model.trim="InsuredModel.pinyin"
            label="被保人拼音:"
            value="请输入投保人拼音"
          />
        </div>
        <div class="item">
          <van-field
            required
            label="证件类型:"
            value="请选择证件类型"
            v-model.trim="InsuredModel.idType"
            @blur="yanzhengBlur('idType',InsuredModel.idType)"
            @click="InsuredIdTypeFlag = true"
            readonly
            right-icon="arrow-down"
          />
          <!--  v-if="InsuredModel.idCode" -->
        </div>
        <div class="item">
          <van-field
            required
            v-model.trim="InsuredModel.idCode"
            @blur="yanzhengBlur('idCode',InsuredModel.idCode)"
            label="证件号码:"
            value="请输入证件号码"
          />
        </div>
        <div class="item">
          <van-field
            required
            label="性别:"
            value="请选择性别"
            v-model.trim="InsuredModel.sex"
            @click="InsuredSexFlag = true"
            readonly
            right-icon="arrow-down"
          />
        </div>
        <div class="item">
          <van-field
            required
            label="出生日期:"
            value="请选择出生日期"
            @blur="yanzhengBlur('birthDay',InsuredModel.birthDay)"
            v-model.trim="InsuredModel.birthDay"
            @click="InsuredBirthdayFlag = true"
            readonly
            right-icon="calender-o"
          />
        </div>
        <div class="item">
          <van-field
            v-model.trim="InsuredModel.phone"
            type="number"
            label="手机号码:"
            value="请输入投保联系方式"
          />
        </div>
        <!-- <div class="item">
          <van-field
            v-model.trim="InsuredModel.email"
            label="邮箱:"
            value="请输入投保人邮箱用于接收保单"
          />
        </div> -->
        <div class="btns" style="flex-direction: column">
          <div class="btn" @click="addOneInsured()">完成</div>
          <div
            @click="InsuredFlag = false"
            class="back"
            style="
              font-size: 14px;
              color: #666;
              height: 20px;
              line-height: 20px;
              margin-top: 10px;
            "
          >
            我不想填了
          </div>
        </div>
      </van-popup>

      <!-- <van-calendar v-model.trim="showCal" type="multiple" @confirm="onConfirmCal" /> -->
      <!-- <calendar
          :show.sync="birthdayFlag"
          @change="onConfirmBirth"
          >
      </calendar>-->

      <van-popup v-model.trim="birthdayFlag" position="bottom">
        <van-datetime-picker
          type="date"
          title="选择出生日期"
          @confirm="onConfirmBirth"
          :min-date="minDate"
          :max-date="maxDate"
          v-model="currentDate"
          @cancel="birthdayFlag = false"
        />
      </van-popup>

      <!-- 被保 -->
      <!-- <calendar
          :show.sync="InsuredBirthdayFlag"
          @change="onConfirmBirthInsured"
          :defaultDate="InsuredModel.birthDayTime"
          >
      </calendar>-->
      <van-popup v-model.trim="InsuredBirthdayFlag" position="bottom">
        <van-datetime-picker
          v-model.trim="InsuredModel.currentDate"
          type="date"
          title="选择年月日"
          @confirm="onConfirmBirthInsured"
          :min-date="minDate"
          :max-date="maxDate"
          @cancel="InsuredBirthdayFlag = false"
        />
      </van-popup>

      <van-dialog
        v-model="noticePdfFlag"
        confirmButtonColor="#00d385"
        :showConfirmButton="false"
        width="95%"
      >
        <div class="noticePdf" style="padding: 10px">
          <div class="title">确认进入投保流程</div>
          <div class="info">
            <p>尊敬的客户：</p>
            <p class="in">
              您即将进入投保流程，请仔细阅读保险条款。本保险产品由【
              <span>{{ detail.insuranceCompany }}</span>
              】承保，由希望天源保险经纪有限公司提供销售和协助理赔等保险服务。
            </p>
            <p class="in">
              投保前请仔细阅读
              <span
                @click="
                  preview(
                    detail.noticePdf[0].response.url,
                    detail.noticePdf[0].name
                  )
                "
                >客户告知书</span
              >
            </p>
            <p class="huang">
              点击“确认”即可开始投保，您在销售页面的操作将被依法记录和保存。
            </p>
          </div>
        </div>
         <div class="dialog-footer">
          <!-- <van-button type="primary" style="width:100%" :disabled="abledBut" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保<span v-if="countDown != 0">({{countDown}})</span> </van-button> -->
          <van-button type="primary" style="width:100%"  @click="preview(detail.noticePdf[0].response.url,detail.noticePdf[0].name)" >确认开始投保 </van-button>
        </div>
        <!-- :disabled="abledBut"  -->
        <!--  <span v-if="countDown != 0">({{countDown}}s)</span>  -->
        <span slot="footer" class="dialog-footer">
          <van-button @click="noticePdfCancel()">暂不投保</van-button>
          <van-button type="primary" @click="noticePdfFlag = false;noticePdfFlag1 = false;">确认开始投保</van-button>
          <!--  :disabled="abledBut" -->
          <!-- <span v-if="countDown != 0">({{countDown}})</span>  -->
          <!-- <van-button
            type="primary"
            @click="
              noticePdfFlag = false;
              noticePdfFlag1 = false;
            "
            >确认开始投保</van-button
          > -->
        </span>
      </van-dialog>

      <van-dialog
        v-model="regPdfFlag"
        confirmButtonColor="#00d385"
        confirmButtonText="已阅读"
        :showConfirmButton="false"
        :width="pageWidth"
      >
        <div>
          <div
            style="
              max-height: 450px;
              overflow-y: scroll;
              -webkit-overflow-scrolling: touch;
            "
          >
            <div>
              <pdf
                :src="regPdfFUrl"
                :page="currentPage"
                @num-pages="pageCount = $event"
                @page-loaded="currentPage = $event"
                @loaded="loadPdfHandler"
              >
              </pdf>
            </div>
          </div>

          <p
            class="arrow"
            style="
              display: flex;
              justify-content: space-evenly;
              align-items: center;
              height: 50px;
            "
          >
            <span
              @click="changePdfPage(0)"
              class="turn"
              :style="{ color: currentPage == 1 ? 'gray' : '' }"
              >Preview</span
            >
            {{ currentPage }} / {{ pageCount }}
            <span
              @click="changePdfPage(1)"
              class="turn"
              :style="{ color: currentPage == pageCount ? 'gray' : '' }"
              >Next</span
            >
          </p>
        </div>
        <div class="dialog-footer">
           <van-button type="primary" style="width:100%" @click="noticePdfFlag = false;noticePdfFlag1 = false;regPdfFlag = false" >我已阅读并同意</van-button>
           <!-- <span v-if="countDown != 0">({{countDown}}s)</span>  :disabled="abledBut"  -->
        </div>
      </van-dialog>
      <!--  -->
      <van-dialog
        @closed="closedIsReady2"
        :showConfirmButton="false"
        v-model="isReady2Flag"
        :width="pageWidth"
      >
        <div>
          <van-tabs v-model="isReady2Index">
            <van-tab title="《详细条款与除外责任》" name="1">
              <div class="isReady_content">
                <ul class="ui-mb20">
                  <li v-for="(item,index) in detailsFiles1" :key="index">
                    <b style="font-size:12px"><a @click="preview(item.url,item.name)">{{item.name}}</a></b>
                    <!-- <pdf :src="regPdfFUrl" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler" ></pdf> -->
                  </li>
                </ul>
                 <!-- <pdf :src="regPdfFUrl" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler" ></pdf> -->
                <!-- <div class="content" v-html="detail.exemption"></div> -->
              </div>
            </van-tab>
            <van-tab title="《投保须知》" name="2">
              <div class="isReady_content">
                <!-- <div class="content" v-html="detail.agreement"></div> -->
                 <ul class="ui-mb20">
                  <li v-for="(item,index) in detailsFiles2" :key="index">
                    <b style="font-size:12px"><a @click="preview(item.url,item.name)">{{item.name}}</a></b>
                  </li>
                </ul>
                <!-- <pdf :src="regPdfFUrl" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler" ></pdf> -->
              </div>
            </van-tab>
            <van-tab title="《服务指引》" name="3">
              <div class="isReady_content">
                <pdf :src="regPdfFUrl1" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler" ></pdf>
                <!-- <div class="content" v-html="detail.insureNotice"></div> -->
              </div>
            </van-tab>
            <van-tab title="《客户告知书》" name="4">
              <div class="isReady_content">
                <!-- <div class="content" v-html="detail.insureNotice"></div> -->
                <pdf :src="regPdfFUrl2" :page="currentPage" @num-pages="pageCount = $event" @page-loaded="currentPage = $event" @loaded="loadPdfHandler" ></pdf>
              </div>
            </van-tab>
          </van-tabs>
          <div
            style="
              display: flex;
              justify-content: center;
              height: 60px;
              align-items: center;
            "
          >
            <van-button
              type="primary"
              @click="changeIsReady2Index(isReady2Index)"
            >
            <!--  :disabled="abledBut"  -->
              我已阅读 <span v-if="isReady2Index == 1">《详细条款与除外责任》</span
              ><span v-if="isReady2Index == 2">《投保须知》</span
              ><span v-if="isReady2Index == 3">《服务指引》</span>
              <span v-if="isReady2Index == 4">《客户告知书》</span>
              <!--  <span v-if="countDown != 0">({{countDown}})</span> -->
            </van-button>
          </div>
        </div>
      </van-dialog>

      <van-dialog
        @closed="closedIsReady1"
        :showConfirmButton="false"
        v-model="isReady1Flag"
        :width="pageWidth"
      >
        <div>
          <van-tabs v-model="isReady1Index">
            <van-tab title="《免责内容》" name="1">
              <div class="isReady_content">
                <div class="content" v-html="detail.exemption"></div>
              </div>
            </van-tab>
            <van-tab title="《被保险人同意声明》" name="2">
              <div class="isReady_content">
                <div class="content" v-html="detail.agreement"></div>
              </div>
            </van-tab>
            <van-tab title="《投保提示》" name="3">
              <div class="isReady_content">
                <div class="content" v-html="detail.insureNotice"></div>
              </div>
            </van-tab>
          </van-tabs>
          <div
            style="
              display: flex;
              justify-content: center;
              height: 60px;
              align-items: center;
            "
          >
            <van-button
              type="primary"
              @click="changeIsReady1Index(isReady1Index)"
            >
            <!-- :disabled="abledBut"  -->
              我已阅读 <span v-if="isReady1Index == 1">《免责内容》</span
              ><span v-if="isReady1Index == 2">《被保险人同意声明》</span
              ><span v-if="isReady1Index == 3">《投保提示》</span> 
              <!-- <span v-if="countDown != 0">({{countDown}})</span> -->
            </van-button>
          </div>
        </div>
      </van-dialog>

      <van-popup
        v-model="slectNameFlag"
        @close="
          slectNameFlag = false;
          nameFormList = [];
          nameFormIndex = -1;
          nameList = [];
          nameCheckeAll = false;"
        round
        position="bottom"
        :closeable="true"
        :close-on-click-overlay="false"
        :style="{ height: '60%' }"
      >
        <div class="slectName-pop">
          <div class="selectChoose" v-if="!nameList.length && nameFormIndex == -1" style="padding-top:50px">
          <!-- <div class="selectChoose" v-if="!nameList.length && nameFormIndex == -1" style="padding-top:70px"> -->
            <van-checkbox v-model="checkAll" shape="square" @change='handleCheckAll' style="height:35px;margin-right:10px;margin-left:15px;position:absolute;top:20px">全选</van-checkbox>
            <van-button type="danger" style="height:35px;position:absolute;top:20px;left:90px" @click="delNameForm">删除</van-button>
              <van-checkbox-group v-model="checked" @change="handleCheck">
                <van-checkbox
                style="height:50px; border-bottom:1px solid #cccccc;margin-left:15px"
                  class="item"
                  v-for="(item,index) in nameFormList"
                  shape="square"
                  :name="item.id"
                  :key="item.id">
                   <!-- {{item.title}} -->
                  <p style="width: 280px;" @click="choseNameForm(item,index)">{{item.title}}</p> 
                </van-checkbox>
              </van-checkbox-group> 
          </div>
          <div class="namelist-box" v-if="nameList.length && nameFormIndex != -1">
            <div class="top-banner">
              <van-checkbox class="check" v-model="nameCheckeAll">全选</van-checkbox>
              <div class="title">{{ nameFormList[nameFormIndex].title }}</div>
            </div>
            <div class="name-list">
              <div class="name-item" v-for="(item, index) in nameList" :key="index">
                <div class="check">
                  <van-checkbox @change="changeNameItemChecked"  v-model="item.$checked" ></van-checkbox>
                </div>
                <div class="title">{{ item.name }} {{ item.idCode }}</div>
              </div>
            </div>
            <div class="import-btn" @click="importNameFn()">确认导入</div>
          </div>
        </div>
      </van-popup>
    </div>

    <!-- 粘贴 -->
    <van-dialog
      class="copy-text"
      v-model.trim="isShowPay"
      title="支付方式"
      width="250"
      show-cancel-button
      @confirm="payOrder()"
    >
    <!-- 支付方式 -->
      <div class="box copy_text" style="padding: 20px; box-sizing: border-box">
        <van-radio-group v-model="payType">
          <van-radio
            checked-color="#2ADA78"
            shape="square"
            :name="3"
            style="margin-bottom: 15px"
          >
            <div
              style="
                font-size: 12px;
                color: #333;
                font-weight: 600;
                display: flex;
                align-items: center;
              "
            >
              <img
                style="width: 25px; margin-right: 10px"
                src="./assets/images/dai.png"
                alt=""
              />
              余额支付
            </div>
          </van-radio>
          <van-radio checked-color="#2ADA78" shape="square" :name="1">
            <div
              style="
                font-size: 12px;
                color: #333;
                font-weight: 600;
                display: flex;
                align-items: center;
              "
            >
              <img
                style="width: 25px; margin-right: 10px"
                src="./assets/images/wechat.png"
                alt=""
              />
              微信支付
            </div>
          </van-radio>
          <van-radio checked-color="#2ADA78" style="margin-top:15px;" shape="square" :name="2">
            <div
              style="
                font-size: 12px;
                color: #333;
                font-weight: 600;
                display: flex;
                align-items: center;
              "
            >
              <img
                style="width:25px; margin-right: 10px"
                src="./assets/images/xinyong.png"
                alt=""
              />
              信用支付
            </div>
          </van-radio>
        </van-radio-group>
      </div>
    </van-dialog>

    <selectAddr
      ref="selectAddr"
      :needSelect="detail.goDestnations"
      :value.sync="destinationArr"
    />
  </div>
</template>

<script>
import {
  Step,
  Steps,
  Popup,
  Picker,
  Field,
  Toast,
  Checkbox,
  CheckboxGroup,
  DatetimePicker,
  Collapse,
  CollapseItem,
  Icon,
  Dialog,
  Form,
  RadioGroup,
  Radio,
  Tab,
  Tabs,
  Button,
  Cell,
} from "vant";
import pdf from "vue-pdf";
import wechatService from "@/services/request/wechatService.js";
import util from "@/libs/util.js";
import Vue from "vue";
Vue.use(Dialog);
// import Calendar from 'vue-mobile-calendar'
import storejs from "store";
import moment from "moment";
var wx = require("weixin-js-sdk");
import loadPinYinInit from "./ChineseHelper.js";
import weui from "weui.js";
import selectAddr from "./selectAddr.vue";
import { mapActions,mapState } from "vuex";
import { SwipeCell } from 'vant';
export default {
  name: "Index",
  components: {
    [Step.name]: Step,
    [Steps.name]: Steps,
    [Popup.name]: Popup,
    [Picker.name]: Picker,
    [Field.name]: Field,
    [Toast.name]: Toast,
    // [Calendar.name]:Calendar,
    [Checkbox.name]: Checkbox,
    [CheckboxGroup.name]: CheckboxGroup,
    [DatetimePicker.name]: DatetimePicker,
    [Collapse.name]: Collapse,
    [CollapseItem.name]: CollapseItem,
    [Icon.name]: Icon,
    [Dialog.name]: Dialog,
    [Form.name]: Form,
    [RadioGroup.name]: RadioGroup,
    [Radio.name]: Radio,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Button.name]: Button,
    [Cell.name]: Cell,
    pdf,
    selectAddr,
    SwipeCell 

    // Calendar
  },
  data() {
    return {
      checked: [],
      checkAll: false,
      that: this,
      pageHeight: window.innerHeight,
      moment: moment,
      publicData: storejs.get("publicData"),
      id: this.$route.query.id,
      startAge: this.$route.query.startAge,
      endAge:this.$route.query.endAge,
      minDate: new Date(1920, 0, 1),
      maxDate: new Date(2025, 10, 1),
      minDate1: new Date(1920, 0, 1),
      maxDate1: new Date(2025, 10, 1),
      detail: "",
      setAges: [],
      plans: [],
      subchecked: false,
      copyFlag: false,
      copyText: "",
      // 第一步
      stepActive: 0,
      chosePlanFlag: false,
      destinationArr: [],
      step1Data: {
        name: "",
        planName: "",
        planIndex: 0,
        planAge: "",
        planAddr: "中国大陆",
        startTime: "",
        endTime: "",
      },
      showCal: false,
      idTypeFlag: false,
      sexFlag: false,
      birthdayFlag: false,
      idTypeOption: ["身份证", "护照", "其他"],
      idTypeOptions: ["社会信用代码","身份证", "护照", "其他"],
      idTypeOptionw: ["护照", "其他"],
      //投保人信息是否有问题
      insureError: {
        name: false,
        idCode: false,
        birthday: false,
        phone: "",
      },
      policyHolder: {
        //投保人信息
        name: "",
        pinyin: "",
        idType: "身份证",
        idCode: "",
        sex: "男",
        birthDay: "",
        birthDayTime: moment(1594137600000).format("YYYY-MM-DD"),
        phone: "",
        email: "",
        currentDate: "",
      },
      currentDate: "",
      InsuredFlag: false,
      //被保人信息中间处理
      InsuredIdTypeFlag: false,
      InsuredSexFlag: false,
      InsuredBirthdayFlag: false,
      openInsureType: "add",
      openInsureIndex: "",
      InsuredList: [],
      InsuredModel: {
        name: "",
        pinyin: "",
        idType: "身份证",
        idCode: "",
        sex: "男",
        birthDay: "",
        birthDayTime: "",
        phone: "",
        email: "",
        currentDate: "",
      },
      // step2data
      activeNames: ["1", "2", "3"],
      //FOOT
      oneprice: 0,
      price: 0,
      totalPrice: 0,
      discount: 0,
      calculateStartTime: "",
      calculateEndTime: "",
      billId: "", //订单id
      insuredEditType: 1, //被保人填写方式
      insuredEditFlag: false,
      subErrinfos: [], //提交订单的错误信息
      wechatPayQr: {
        url: "",
        title: "",
        tip: "请长按识别二维码",
      },
      regPdfFlag: false,
      regPdfFUrl: "",
      regPdfFUrl1:"",
      regPdfFUrl2:"",
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      fileType: "pdf", // 文件类型
      pageWidth: window.innerWidth - 10,
      //确认进入投保流程
      noticePdfFlag: false,
      noticePdfFlag1: false,
      //逐步阅读条款
      isReady: false,
      isReady1: false,
      isReady1Flag: false,
      isReady1Index: "1",

      isReady2: false,
      isReady2Flag: false,
      isReady2Index: "1",
      isReady2Arr: [0, 0, 0, 0],

      isReady1Arr: [0, 0, 0],
      todayBuyMin: 0,
      openId: "",
      unionId: "",
      idNumList:[],
      //选择名单
      slectNameFlag: false,
      nameFormList: [],
      nameFormIndex: -1,
      nameList: [],
      nameCheckeAll: false,
      isShowPay: false,
      payType: 1,
      orderIds: "",
      multipleSelection:[],
      // 保期
      currentTime: new Date(2023, 11, 31),
      // currentTime: new Date(), // 开始时间不能超过当前时间
      startTime: new Date(), // 开始时间
      endTime: new Date(), // 结束时间
      datePicker: '', // 用于判断哪个选择器的显示与隐藏
      isPopShow: false, // 弹出层隐藏与显示
      abledBut:false,
      countDown: 0,//设置初始时间为0
      timerThree: null,
      detailsFiles2:[],
      detailsFiles1:[]
    };
  },
  watch: {
    policyHolder: {
      //投保人监听
      handler(val) {
        console.log(val)
        if (this.policyHolder.idType == "身份证") {
          if (this.policyHolder.idCode.length == 18) {
            if(!util.isCardID(val.idCode)){
              return
            }
            let birthday = this.getBirthdayFromIdCard(this.policyHolder.idCode);
            // console.log("birthday", birthday);
            val.birthDay = birthday;
            if (parseInt(this.policyHolder.idCode.substr(16, 1)) % 2 == 1) {
              val.sex = "男";
            } else {
              val.sex = "女";
            }
          }
        }else if(this.policyHolder.idType == "社会信用代码"){
          val.birthDay = ''
        }
       
        
        
      },
      deep: true,
    },
    InsuredModel: {
      //被保人监听
      handler(val) {
        // console.log(val)
        if (this.InsuredModel.idType == "身份证") {
          // console.log(66);
          if (this.InsuredModel.idCode.length == 18) {
            // console.log(77);
            let birthday = this.getBirthdayFromIdCard(this.InsuredModel.idCode);
            // console.log("birthday", birthday);
            this.InsuredModel.birthDay = birthday;
            this.InsuredModel.currentDate = birthday;
            this.InsuredModel.birthDayTime = birthday;
            if (parseInt(this.InsuredModel.idCode.substr(16, 1)) % 2 == 1) {
              this.InsuredModel.sex = "男";
            } else {
              this.InsuredModel.sex = "女";
            }
          }
        }
        
        if (this.detail.hasPinyin) {
          val.pinyin = loadPinYinInit.ConvertPinyin(val["name"]);
        }
        // this.InsuredModel['pinyin'] = loadPinYinInit.ConvertPinyin(this.InsuredModel['name'])

      },
      deep: true,
    },
    InsuredFlag: function(val){
      if(val){
        this.setFlag(false)
      }else{
        this.setFlag(true)
      }
    },
    nameCheckeAll: function (val) {
      if (val) {
        this.nameList.forEach((el) => {
          el.$checked = true;
        });
      }
    },
    destinationArr: function (val) {
      if (val && val.length) {
        this.step1Data.planAddr = val.join(",");
      }else{
        this.step1Data.planAddr = ''
      }
    },

  },
  mounted() {
    if (this.publicData.accountBasic && this.publicData.accountBasic.insurePeople) {
        this.publicData.accountBasic.insurePeople = JSON.parse(this.publicData.accountBasic.insurePeople);
      if (this.publicData.accountBasic.insurePeople.length) {
        let insurePeople = this.publicData.accountBasic.insurePeople[0];
        this.policyHolder = {
          //投保人信息
          name: insurePeople.name,
          pinyin: insurePeople.pinyin || loadPinYinInit.ConvertPinyin(insurePeople["name"]),
          idType: insurePeople.idType,
          idCode: insurePeople.idCode,
          sex: insurePeople.sex == 1 ? "男" : "女",
          birthDay: insurePeople.birthDate?this.moment(insurePeople.birthDate).format("YYYY-MM-DD"):'',
          birthDayTime: insurePeople.birthDate || "",
          phone: insurePeople.phone,
          email: insurePeople.email,
          currentDate: insurePeople.birthDate || "",
        };
      }
    }
    this.init();
    if (this.$page.isInWechat) {
      wechatService.auth(
        0,
        ({ openid, unionid }) => {
          if (!!openid && !!unionid) {
            this.unionId = unionid;
            this.openId = openid;
          }
        },
        false
      );
    }
  },
  methods: {
    ...mapActions("d2admin/topBack", ["setFlag"]),
    ...mapActions("d2admin/user", ["setNewUser"]),

    handleCheckAll(val){
      console.log("nameFormList",this.nameFormList )
      let checkedCount = this.checked.length
      if (val) {
        this.checked = this.nameFormList.map(item => item.id)
        // console.log("cccccc",this.checked)
      } else if (checkedCount === this.nameFormList.length) {
        this.checked = []
      }
    },
    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
	  handleCheck(val){
      // 已选中的ID
      this.multipleSelection=val
      console.log("multipleSelection",this.multipleSelection)
	  	// this.checkAll = this.checked.length === this.nameFormList.length
	  },
    openSelectAddr() {
      this.$refs.selectAddr.isShow = true;
    },
    async openName() {
      await this.getNameList();
      this.slectNameFlag = true;
    },
    async getNameList() {
      let res = await this.$http.post("/api/collectForm/getList", {
        queryKey: "",
        accountId: this.publicData.id,
        pageNumber: 1,
        pageSize: 100,
      });
      if (!res.code) {
        // console.log("res", res);
        this.nameFormList = res.list;
      }
    },
    async choseNameForm(item, index) {
      this.nameFormIndex = index;
      this.getListFromId();
    },
    // 删除
    async delNameForm(){
      console.log("this.multipleSelection",this.multipleSelection)
      let strArr=this.multipleSelection
      Dialog.confirm({
        title: "提示",
        // message: `确定要删除收集列表号为“${item.title}”的名单吗？`,
        message: `确定要删除已选中的列表名单吗？`
      })
        .then(async () => {
          let res = await this.$http.post("/api/collectForm/batchDelete", {
            // id: item.id,
            id:JSON.stringify(strArr),
            formId:this.$route.query.id,
          });
          if (!res.code) {
            this.$toast("删除成功！");
            this.getNameList();
            // this.params.pageNumber = 1;
          } else {
            this.$toast(res.msg);
          }
        })
        .catch(() => {
          // on cancel
        });
    },
    async getListFromId() {
      let params = { pageSize: 100, pageNumber: 1, queryKey: "" };
      params.accountId = this.publicData.id;
      params.collectFormId = this.nameFormList[this.nameFormIndex].id;
      let res = await this.$http.post("/api/collectForm/getNameList", params);
      if (!res.code) {
        res.list.forEach((el) => {
          el.$checked = false;
        });
        this.nameList = res.list;
        // console.log("res", res);
      }
    },
    changeNameItemChecked(val) {
      console.log("val", val);
      if (!val) {
        this.nameCheckeAll = false;
      }
    },
    async importNameFn() {
      this.nameList.forEach((el) => {
        console.log("el", el);
        if (el.$checked) {
          let obj = {
            name: el.name,
            pinyin: loadPinYinInit.ConvertPinyin(el.name) || "",
            birthday: el.birthday,
            currentDate: this.moment(el.birthday).format("YYYY-MM-DD"),
            idCode: el.idCode,
            idType: el.idType,
            // mailbox: el.mailbox || "",
            sex: el.sex == "男" ? 1 : 2,
            num: 1,
            phone: el.mobile,
          };
          this.InsuredList.push(obj);
        }
      });
      this.slectNameFlag = false;
      this.nameFormList = [];
      this.nameFormIndex = -1;
      this.nameList = [];
      this.nameCheckeAll = false;

      console.log("InsuredList", this.InsuredList);
      this.calculateOrder();
    },
    changeIsReady1Index(index) {
      console.log("this.isReady1Arr",this.isReady1Arr)
      if (index == 1) {
        this.isReady1Index = String(2);
        this.isReady1Arr[0] = 1;
      }
      if (index == 2) {
        this.isReady1Index = String(3);
        this.isReady1Arr[1] = 1;
      }
      if (index == 3) {
        this.isReady1Arr[2] = 1;
        this.isReady1Flag = false;
        this.isReady1 = true;
      }
    },
    changeIsReady2Index(index) {
      console.log("this.isReady2Arr",this.isReady2Arr)
      if (index == 1) {
        this.isReady2Index = String(2);
        this.isReady2Arr[0] = 1;
      }
      if (index == 2) {
        this.isReady2Index = String(3);
        this.isReady2Arr[1] = 1;
        let url = (this.detail.serviceFiles[0].response.url)
        this.regPdfFUrl1 = pdf.createLoadingTask(url);
      }
      if (index == 3) {
        this.isReady2Index = String(4);
        this.isReady2Arr[2] = 1;
        let url = (this.detail.customerFiles[0].response.url)
        this.regPdfFUrl2 = pdf.createLoadingTask(url);
      }
      if (index == 4) {
        this.isReady2Arr[3] = 1;
        this.isReady2Flag = false;
        this.subchecked = true;
      }
    },
    timer1() {
      const TIME_COUNT = 5;
				if (!this.timerThree) {
					this.countDown = TIME_COUNT;
					this.timerThree = setInterval(() => {
						if (this.countDown > 1 && this.countDown <= TIME_COUNT) {
							this.countDown--;
						} else {
              this.countDown = 0
							clearInterval(this.timerThree);
              // this.abledBut = false;
              this.timerThree = null;
						}
					}, 1000)
				}
    },
    closedIsReady1() {
      this.isReady1Arr.forEach((el, i) => {
        if (!el) {
          this.isReady1 = false;
        }
      });
    },
    closedIsReady2() {
      this.isReady2Arr.forEach((el, i) => {
        if (!el) {
          this.subchecked = false;
        }
      });
    },
    chageReady1(val) {
        //投保新规则
        if (val) {
          this.isReady1Arr.forEach((el, i) => {
            if (!el) {
              this.isReady1Flag = true;
              this.isReady1Arr[0] = 1;
              // this.abledBut = true
              // this.timer1();
            }
          });
        }
    },
    chageReady2(val) {
        //投保新规则
        if (val) {
          this.isReady2Arr.forEach((el, i) => {
            if (!el) {
              this.isReady2Flag = true;
              this.isReady2Arr[0] = 1;
              // this.abledBut = true
              // this.timer1();
            }
          });
        }
    },
    noticePdfCancel() {
      this.noticePdfFlag = false;
      this.noticePdfFlag1 = true;
    },
    noticePdfCheck() {
      if (this.noticePdfFlag1) {
        setTimeout(() => {
          this.noticePdfFlag = true;
        }, 100);
        return true;
      } else {
        return false;
      }
    },
    gotoPreview(type) {
      if (type == 1) {
        this.$router.push({
          name: "Preview",
          params: {
            id: this.detail.id,
          },
          query: {
            type: type,
          },
        });
      }
      if (type == 2) {
        this.$router.push({
          name: "Preview",
          params: {
            id: this.detail.id,
          },
          query: {
            type: type,
          },
        });
      }
    },
    preview(url, filename) {
      console.log("urlllll-------->",url)
      console.log("typeof------->",typeof(url))
      this.regPdfFUrl = pdf.createLoadingTask(url);
      // this.abledBut = true
      this.regPdfFlag = true;
      // this.timer1()
      // console.log(url, filename);
      // this.getBlob(url,  (blob)=> {
      //     this.previewAS(blob, filename);
      // });
    },
    preview2(url, filename) {
      this.regPdfFUrl = pdf.createLoadingTask(url);
      this.regPdfFlag = true;
    },
    blurInsure(type, val, toast,fuzhiFlag) {
      if (type == "name") {
        if(this.policyHolder.idType == "社会信用代码"){
          let regs = /^[\u4e00-\u9fa5()（）]+$/;
          if (!regs.test(this.policyHolder["name"])) {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("姓名格式不正确");
          }
          return true;
        }else{
          this.insureError.name = false;
          return false;
        }
        }else{
          // console.log("this.policyHolder",this.policyHolder["name"]);
        let reg = /^[a-zA-Z\/ ]{2,20}$/;
        let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/;
        if (val == "") {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("投保人姓名有误");
          }
          return true;
        } else if (this.policyHolder["name"].length < 2) {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("姓名填写不完整");
          }
          return true;
        } else if (!regs.test(this.policyHolder["name"])) {
          this.insureError.name = true;
          if (toast == true) {
            this.$toast("姓名格式不正确");
          }
          return true;
        } else if (reg.test(this.policyHolder["name"])) {
          this.policyHolder["name"] = this.policyHolder["name"].toUpperCase();
          if (!fuzhiFlag) {
            this.idTypeOptions = ["护照", "其他"];
            this.policyHolder["idType"] = "护照";
          }
        } else {
          this.policyHolder["pinyin"] = loadPinYinInit.ConvertPinyin(this.policyHolder["name"]);
          this.insureError.name = false;
          this.idTypeOptions = ["社会信用代码", "身份证", "护照", "其他"];
          return false;
        }
        }
      }
      if (type == "pinyin") {
        if (val == "") {
          this.insureError.pinyin = true;
          if (toast == true) {
            this.$toast("投保人拼音有误");
          }
          return true;
        } else {
          this.insureError.pinyin = false;
          return false;
        }
      }
      if (type == "idCode") {
        if (this.policyHolder.idType == "身份证") {
          if (!util.isCardID(val)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        }else if (this.policyHolder.idType == "护照") {
          let PassportNumberReg = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/
          if (!PassportNumberReg.test(val)) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("护照号码格式错误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        }else if (this.policyHolder.idType == "其他") {
          let has= this.isOther(val)
            if(has){
              this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("证件格式错误");
            }
            return true;
            }else{
               this.insureError.idCode = false;
              return false;
            }
        }else if (this.policyHolder.idType != "身份证" && this.policyHolder.idType != '社会信用代码') {
          if (!val) {
            this.insureError.idCode = true;
            if (toast == true) {
              this.$toast("投保人证件号有误");
            }
            return true;
          } else {
            this.insureError.idCode = false;
            return false;
          }
        }
      }
      if (type == "birthday") {
        // if(!val){
        //   this.insureError.birthday = true
        //   this.$toast('投保人出生日期不能为空')
        //   return
        // }
        // let birthday = that.moment(val).format("YYYY-MM-DD");
        // let endDate = that.moment(
        //   that.step1Data.startTime
        //     ? that.step1Data.endTime
        //     : new Date().getTime()
        // ).format("YYYY-MM-DD");
        // let age = that.jsGetAge(birthday, endDate);
        // if(age<18){
        //   this.insureError.birthday = true
        //   this.$toast('投保人年龄不能为小于18岁')
        // }else{
        //   this.insureError.birthday = false
        // }
      }
      if (type == "phone") {
        if (!util.isPone(val)) {
          if (toast == true) {
            this.$toast("投保人手机号有误");
          }
          this.insureError.phone = true;
          return true;
        } else {
          this.insureError.phone = false;
          return false;
        }
      }
    },
    yanzhengBlur(type,val,fuzhiFlag){
      if(type == "name"){
        let reg=/^[a-zA-Z\/ ]{2,20}$/;
        let regs_test =/^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/
        if (val == "") {
            this.$toast("投保人姓名有误");
        }else if(this.InsuredModel['name'].length < 2){
            this.$toast("姓名填写不完整");
        }else if(!regs_test.test(this.InsuredModel['name'])){
            this.$toast("姓名格式不正确");
        } else if(reg.test(this.InsuredModel['name'])){
          this.InsuredModel['name'] = this.InsuredModel['name'].toUpperCase()
          if(!fuzhiFlag){
            this.idTypeOption=["护照","其他"]
            this.InsuredModel['idType']="护照"
          }
        }  else {
          this.InsuredModel["pinyin"] = loadPinYinInit.ConvertPinyin(this.InsuredModel["name"]);
          this.idTypeOption=["身份证", "护照", "其他"]
        }
      }
    },
    changeInsuredEditType(val) {
      // console.log(val);
    },
    changeInsuredEdit(val) {
      // console.log(val);
      try {
        if (val) {
          //为true需要验证投保人信息是否填写
          // console.log(this.policyHolder);
          if (this.policyHolder.name == "") {
            this.$toast("投保人信息不完整-姓名");
            this.insuredEditFlag = false;
            return;
          }
          if (this.detail.hasPinyin && !this.policyHolder.pinyin) {
            this.$toast("投保人信息不完整-拼音");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.idCode == "") {
            this.$toast("投保人信息不完整-证件号");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.idType == "") {
            this.$toast("投保人信息不完整-证件类型");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.birthDay == "") {
            this.$toast("投保人信息不完整-出生日期");
            return;
          }
          if (this.policyHolder.sex == "") {
            this.$toast("投保人信息不完整-性别");
            this.insuredEditFlag = false;
            return;
          }
          if (this.policyHolder.phone == "") {
            this.$toast("投保人信息不完整-手机号");
            this.insuredEditFlag = false;
            return;
          }
          console.log("验证通过");
          if (this.InsuredList.length == 0) {
            //length == 0直接写入到第0个
            let dataItem = {
              name: this.policyHolder.name,
              pinyin: this.policyHolder.pinyin || "",
              idCode: this.policyHolder.idCode,
              sex: this.policyHolder.sex == "男" ? 1 : 2,
              birthday: this.moment(this.policyHolder.birthDay).valueOf(),
              phone: this.policyHolder.phone,
              num: 1,
              // mailbox: "",
              idType: this.policyHolder.idType,
              currentDate: this.policyHolder.currentDate,
            };
            this.InsuredList.push(dataItem);
            this.calculateOrder();
          } else {
            Dialog.confirm({
              title: "提示",
              message:
                "监测到您已经添加过被保人，再次进行此操作将会用投保人信息替换掉第一个被保人信息",
            })
              .then(() => {
                // on confirm
                let dataItem = {
                  name: this.policyHolder.name,
                  pinyin: this.policyHolder.pinyin || "",
                  idCode: this.policyHolder.idCode,
                  sex: this.policyHolder.sex == "男" ? 1 : 2,
                  birthday: this.moment(this.policyHolder.birthDay).valueOf(),
                  phone: this.policyHolder.phone,
                  num: 1,
                  // mailbox: "",
                  idType: this.policyHolder.idType,
                  currentDate: this.policyHolder.currentDate,
                };
                let list = JSON.parse(JSON.stringify(this.InsuredList));
                list[0] = dataItem;
                this.InsuredList = list;
                this.calculateOrder();
              })
              .catch(() => {
                this.insuredEditFlag = false;
                // on cancel
              });
          }
        }
      } catch (error) {
        this.$toast(error.msg);
      }
    },
    checkIdcode(val) {
      //检查
      // console.log(val);
      return false;
    },
    onFailed(errorInfo) {
      // console.log("failed", errorInfo);
    },
    // 获取年龄
    getAge(UUserCard) {
      //获取年龄
      var myDate = new Date();
      var month = myDate.getMonth() + 1;
      var day = myDate.getDate();
      var age = myDate.getFullYear() - UUserCard.substring(6, 10) - 1;
      if (
        UUserCard.substring(10, 12) < month ||
        (UUserCard.substring(10, 12) == month &&
          UUserCard.substring(12, 14) <= day)
      ) {
        age++;
      }
      console.log("ageage获取年龄",age)
      return age;
    },
    getBirthdayFromIdCard(idCard) {
      //根据身份证计算生日格式1997-00-00
      var birthday = "";
      if (idCard != null && idCard != "") {
        if (idCard.length == 15) {
          birthday = "19" + idCard.substr(6, 6);
        } else if (idCard.length == 18) {
          birthday = idCard.substr(6, 8);
        }

        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      return birthday;
    },
    async sendCopyText() {
      // console.log('sendtext',this.enrollUsers)
      // let user = objectAssign({}, this.tpl_enrollUser)
      console.log("this.policyHolder", this.policyHolder);
      console.log("user", this.InsuredList);
      // return
      if (this.copyText == "") {
        this.$toast.fail("请输入名单");
        return;
      }
      let result = await this.$http.post(
        "/api/insuranceProduction/parsePasteInfo",
        { content: this.copyText }
      );
      console.log("result", result);
      if (result.code == 0) {
        if (!!result.t.length) {
          result.t.forEach((el, i) => {
            el = JSON.parse(JSON.stringify(el));
            el.birthday = this.getBirthdayFromIdCard(el.idCode);
            el.birthday = this.moment(el.birthday).valueOf();
            if (parseInt(el.idCode.substr(16, 1)) % 2 == 1) {
              el.sex = "1";
            } else {
              el.sex = "2";
            }
            let ages = this.getAge(el.idCode);
            let adult = 1;
            if (ages < 18) {
              adult = 2;
            }
            console.log("el",el);
            this.InsuredList.push({
              name: el.name,
              pinyin: el.pinyin || loadPinYinInit.ConvertPinyin(el.name),
              idCode: el.idCode,
              sex: el.sex,
              birthday: el.birthday,
              phone: el.phone,
              num: 1,
              // mailbox: "",
              idType: "身份证",
              currentDate: el.birthday,
            });
            // console.log();
          });
          // this.loading.close()
          // this.price = this.InsuredList.length * this.oneprice;
          this.calculateOrder();
          this.copyFlag = false;
          this.copyText = "";
        } else {
          // this.loading.close()
          // this.$message.error(result.msg);
        }
      } else {
        this.$toast.fail(result.msg);
      }
    },
    async changeStep(active) {
      // this.stepActive = 1
      //检测投保人
      let errinfos = [];
      let beibaoErrinfos = [];
      const nameFlag = this.blurInsure("name", this.policyHolder.name,'',true);//第四个参数表示是否禁止赋值操作
      const idCodeFlag = this.blurInsure("idCode", this.policyHolder.idCode);
      const phoneFlag = this.blurInsure("phone", this.policyHolder.phone);
      if (nameFlag) {
        errinfos.push("姓名");
      }
      if (idCodeFlag) {
        errinfos.push("证件号");
      }
      if (phoneFlag) {
        errinfos.push("手机号");
      }
      if(!this.InsuredList.length){
        this.$toast('请添加被保人！')
        return
      }
      //投保人年龄
      let birthdayFlag = false;
      if (!this.policyHolder.birthDay) {
        if(this.policyHolder.idType != '社会信用代码'){
          this.insureError.birthday = true;
          birthdayFlag = true;
          errinfos.push("出生日期");
        }else{
          this.insureError.birthday = false;
        }
        
      } else {
        let birthday = this.moment(this.policyHolder.birthDay).format("YYYY-MM-DD");
        let endDate = this.moment(this.step1Data.startTime ? this.step1Data.endTime : new Date().getTime()).format("YYYY-MM-DD");
        let age = util.jsGetAge(birthday, endDate);
        console.log("age",age)
        if(this.policyHolder.idType != '社会信用代码'){
          if (age < 18) {
            this.insureError.birthday = true;
            birthdayFlag = true;
            errinfos.push("出生日期不足18岁，");
          } else {
            this.insureError.birthday = false;
          }
        }else{
          this.insureError.birthday = false;
        }
      }
      // this.InsuredList.push({
      //   name: el.name,
      //   idCode: el.idCode,
      //   sex: el.sex,
      //   birthday: el.birthday,
      //   phone: el.phone,
      //   num: 1,
      //   mailbox: "",
      //   idType: "身份证",
      //   pinyin: "",
      //   currentDate: el.birthday,
      // });
      this.InsuredList.forEach((el, index) => {
        let flag = false;
        if (!el.name) {
          flag = true;
        }else{
          if (el.name.length <2) {
          console.log("el.name.length",el.name.length)
          flag = true;
        }
        }
        if (!el.idCode) {
          flag = true;
        } else {
          if (el.idType == "身份证") {
            if (!util.isCardID(el.idCode)) {
              flag = true;
            }
          } else if (el.idType != "身份证") {
            if (!el.idCode) {
              flag = true;
            }
          }
          if (el.idType == "护照") {
            let test_idcard = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/
            if(!test_idcard.test(el.idCode)){
              flag = true;
            }
          } else if (el.idType != "护照") {
            if (!el.idCode) {
              flag = true;
            }
          }
          if (el.idType == "其他") {
            let has= this.isOther(el.idCode)
            if(has){
              flag = true;
            }
          } else if (el.idType != "其他") {
            if (!el.idCode) {
              flag = true;
            }
          }
        }
        if (!el.birthday) {
          flag = true;
        } else {
          let birthday = this.moment(el.birthday).format("YYYY-MM-DD");
          let endDate = this.moment(this.step1Data.startTime ? this.step1Data.endTime : new Date().getTime()).format("YYYY-MM-DD");
          let age = util.jsGetAge(birthday, endDate);
          // console.log("ageTwo",age)
          // if (age > this.detail.endAge || age < this.detail.fromAge) {
          if (age > this.endAge || age < this.startAge) {
            flag = true;
          } else {
          }
        }
        if (flag) {
          beibaoErrinfos.push(index + 1);
        }
      });
      for (let i = 0; i < this.InsuredList.length; i++) {
        for (let j = i + 1; j < this.InsuredList.length; j++) {
          if (
            this.InsuredList[i].idCode &&
            this.InsuredList[j].idCode &&
            this.InsuredList[i].idCode==
              this.InsuredList[j].idCode
          ) {
            if (this.InsuredList[i].idType == "身份证") {
              this.$toast('被保人证件号码重复，请检查!')
              return
              continue;
            } else if (this.InsuredList[i].idType== "护照") {
              this.$toast('被保人证件号码重复，请检查!')
              return
              continue;
            } else {
              if (this.InsuredList[j].idCode != "") {
                this.$toast('被保人证件号码重复，请检查!')
                return
                continue;
              }
            }
          }
        }
      }
      console.log("beibaoErrinfos.length",beibaoErrinfos.length)
      if (errinfos.length || beibaoErrinfos.length) {
        Dialog.alert({
          title: "提示",
          message: `${ errinfos.length ? "投保人" + errinfos.join(",") + "有误," : "," }${ beibaoErrinfos.length ? "第" + beibaoErrinfos.join(",") + "行被保人信息有误"  : "" }`,
        }).then(() => {
          // on close
        });
      }

      if (errinfos.length || beibaoErrinfos.length) {
        return;
      }

      //检测被保人
      try {
        await this.calculateOrder();
        await this.batchAdd();
      } catch (error) {
        this.$toast(error.msg);
      }
    },
    // 订单支付
    async calculateOrder() {
      let params = JSON.parse(JSON.stringify(this.step1Data));
      console.log("params", params);
      let res = await this.$http.post("api/bill/calculate", {
        accountId: this.publicData.parentId == 0 ? this.publicData.id : this.publicData.parentId,
        subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
        companyId: this.publicData.companyId,
        startDate: this.calculateStartTime,
        endDate: this.calculateEndTime,
        productId: this.$route.query.id,
        index: this.$route.query.plan,
        size: this.InsuredList.length,
      });
      console.log(res);
      if (res.code == 0) {
        this.totalPrice = res.t.payPrice;
        this.price = res.t.payPrice;
        this.discount = res.t.discount;
      } else {
        this.$toast.fail(res.msg);
      }
    },
    async batchAdd() {
      if (this.detail.hasDestnation) {
        if (!this.step1Data.planAddr) {
          this.$toast("请选择目的地！");
          return;
        }
      }
      let insurePeople = JSON.parse(JSON.stringify(this.policyHolder));
      let InsuredList = JSON.parse(JSON.stringify(this.InsuredList));
      InsuredList.forEach((el) => {
        //性别number 网络错误
        el.sex = String(el.sex);
      });
      InsuredList.forEach((el) => {
        if (el.hasOwnProperty("currentDate")) {
          delete el["currentDate"];
        }
      });
      if (insurePeople.hasOwnProperty("birthDayTime")) {
        delete insurePeople["birthDayTime"];
      }
      if (insurePeople.hasOwnProperty("birthDay")) {
        //可能需要修改日期格式
        insurePeople.birthday = moment(insurePeople.birthDay).valueOf();
        delete insurePeople["birthDay"];
      }
      // if (insurePeople.hasOwnProperty("email")) {
      //   //可能需要修改日期格式
      //   insurePeople.mailbox = insurePeople.email;
      //   delete insurePeople["email"];
      // }
      if (insurePeople.hasOwnProperty("currentDate")) {
        delete insurePeople["currentDate"];
      }
      insurePeople.sex = insurePeople.sex == "男" ? 1 : 2;
      let params = {
        accountId:
          this.publicData.parentId == 0
            ? this.publicData.id
            : this.publicData.parentId,
        subAccountId:
          this.publicData.parentId == 0
            ? this.publicData.parentId
            : this.publicData.id,
        companyId: this.publicData.companyId,
        together: 1,
        insurePeople: JSON.stringify(insurePeople),
        startDate: moment(this.step1Data.startTime).valueOf(),
        endDate: moment(this.step1Data.endTime).valueOf(),
        payType: 1, //1,现金，2信用
        productId: this.detail.id,
        remark: "",
        index: this.$route.query.plan, //保险计划的索引
        destination: this.step1Data.planAddr, //目的地
        infos: JSON.stringify(InsuredList),
        insureType: 2,
        language: "CN",
        startAge:this.startAge,
        endAge:this.endAge,
        source:4

      };
      // if(sure){
      //   addParams.sure = 1
      // }
      let addRes = await this.$http.post("api/bill/batchAdd", params);
      let ids = [];
      if (addRes.code != 0) {
        this.$toast.fail(addRes.msg);
        return;
      }
      // if (addRes.code != 0) {
      //   Dialog.confirm({
      //     title: '提示',
      //     message: `${addRes.msg}`,
      //     confirmButtonText:'继续购买',
      //     cancelButtonText:'返回修改',
      //   })
      //     .then(() => {
      //       this.batchAdd(true)
      //     })
      //     .catch(() => {});
      //   // this.$toast.fail(addRes.msg);
      //   return;
      // }
      // if (addRes.code != 0) {
      //   this.$toast.fail(addRes.msg);
      //   return;
      // }
      addRes.t.forEach((item, i) => {
        ids.push(item.id);
      });
      this.orderIds = ids;
      console.log("ids",ids)
      this.stepActive = 1;
      // await this.buildBill(ids);
    },
    async buildBill(ids) {
      let res = await this.$http.post("api/accountBill/buildBill", {
        accountId: this.publicData.parentId == 0  ? this.publicData.id  : this.publicData.parentId,
        subAccountId: this.publicData.parentId == 0 ? this.publicData.parentId : this.publicData.id,
        together: 0,
        companyId: this.publicData.companyId,
        payType: this.payType,
        relationBillIds: JSON.stringify(ids),
        opName: !!this.publicData.name ? this.publicData.name : "",
        summary: this.detail.title,
        remark: "",
      });
      let flag = true;
      if (res.code == 0) {
        this.billId = res.t.id;
        flag = true;
        if (this.payType == 3 || this.payType==2) {
          await this.setNewUser()

          Dialog.confirm({
          title: '提示',
          message:
            '购买成功！',
            // buttons: [
            //   {
            //     label: "确定",
            //     type: "primary",
            //     onClick: () => {
            //       console.log("ssssssssssss")
            //       console.log("this.$router",this.$router)
            //       this.$router.push({
            //         path: '/tabMine',
            //         query: {
            //           t: new Date().getTime(),
            //         },
            //       });
            //     },
            //   },
            // ],
        })
          .then(() => {
            // on confirm
            console.log("aasasasass")
            console.log("ssssssssssss")
            console.log("this.$router",this.$router)
            this.$router.push({
                name: 'TabMine',
                query: {
                  t: new Date().getTime(),
                },
                isAndroid: false,
            });
            
          })
          .catch(() => {
            // on cancel
            console.log("bbbbbbbbbbb")
            
          });

          // Dialog.confirm({
          //   title: "提示",
          //   message: `购买成功！`,
          //   buttons: [
          //     {
          //       label: "确定",
          //       type: "primary",
          //       onClick: () => {
          //         console.log("ssssssssssss")
          //         console.log("this.$router",this.$router)
          //         this.$router.push({
          //           path: '/tabMine',
          //           query: {
          //             t: new Date().getTime(),
          //           },
          //         });
          //       },
          //     },
          //   ],
          //   isAndroid: false,
          // })
          // Dialog.confirm(`购买成功！`, {
          //   title: "提示",
            // buttons: [
            //   {
            //     label: "确定",
            //     type: "primary",
            //     onClick: () => {
            //       this.$router.push({
            //         name: "TabMine",
            //         query: {
            //           t: new Date().getTime(),
            //         },
            //       });
            //     },
            //   },
            // ],
          //   isAndroid: false,
          // });
          flag = false;
        }
      } else {
        this.$toast.fail(res.msg);
        flag = false;
      }
      return flag;
    },
    prePayOrder() {
      if (!this.subchecked) {
        this.$toast("请先阅读页面下方投保条款后勾选！");
        return;
      }
      if (
        this.detail.exemption ||
        this.detail.agreement ||
        this.detail.insureNotice
      ) {
        //逐条阅读
        for (let i = 0; i < this.isReady1Arr.length; i++) {
          if (!this.isReady1Arr[i]) {
            this.isReady1Flag = true;
            this.isReady1Arr[0] = 1;
            this.$toast(
              "请逐步阅读完并同意《免责内容》《被保险人同意声明》《投保提示》！"
            );
            return false;
          }
        }
      }
      this.isShowPay = true;
    },
    async payOrder() {
      let downFlag = await this.buildBill(this.orderIds);
      if (!downFlag) {
        return;
      }
      var self = this;
      let wechatParams = {
        accountBillId: this.billId,
        paytype: (window.__wxjs_environment === "miniprogram") ? "W06" : "W01",
        acct: this.openId,
      };
      let wechatRes = await this.$http.post(
        "/api/order.union.create",
        wechatParams
      );
      console.log("wechatRes", wechatRes);
      if (wechatRes.code == 0) {
        //成功
        // let data =  JSON.parse(wechatRes.t.payinfo)
        // console.log('payInfo',data)
        // window.open(wechatRes.t.payinfo)
        if (window.__wxjs_environment === "miniprogram") {
          let payinfo = JSON.parse(wechatRes.t.payinfo);
          wx.miniProgram.navigateTo({
            url:
              "/pages/pay/pay?iid=0" +
              "&payInfo=" +
              encodeURIComponent(JSON.stringify(payinfo)) +
              "&from=2",
            success: function () {
              //   window.history.go(-1);
            },
          });
        } else {
          location.href = wechatRes.t.payinfo;
        }

        // let mobilePriviewUrl = encodeURIComponent(`${wechatRes.t.payinfo}`);
        // this.aliPayQr.title = "扫一扫手机预览";
        // this.aliPayQr.url = `http://yun.huaxiyou.cc/internal.qcode.stream?dstUrl=${mobilePriviewUrl}`;
      } else {
        this.$toast.fail(wechatRes.msg);
      }
    },
    addOneInsured() {
       if (this.openInsureType == "add") {
        let InsuredModel = JSON.parse(JSON.stringify(this.InsuredModel));
        // console.log("InsuredModelsss",InsuredModel)
        // console.log("InsuredModel",InsuredModel.idCode)
        if (
          InsuredModel.name == "" ||
          InsuredModel.idType == "" ||
          InsuredModel.idCode == "" ||
          InsuredModel.sex == "" ||
          InsuredModel.birthDayTime == "" ||
          (this.detail.hasPinyin && !InsuredModel.pinyin)
        ) {
          this.$toast.fail("请将被保人信息填写完整");
          return;
        }
        let reg1=/^[a-zA-Z\/ ]{2,20}$/;
        let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/
        let PassportNumberReg = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/
        if(InsuredModel.name.length <2){
          this.$toast.fail("被保人姓名不能只有一个字");
          return
        }
        if(!regs.test(InsuredModel.name)){
          this.$toast.fail("被保人姓名格式错误");
          return
        }
        if(reg1.test(InsuredModel.name)){
          InsuredModel.name=InsuredModel.name.toUpperCase()
          this.idTypeOptions=["护照","其他"]
        }else{
          this.idTypeOptions=["身份证", "护照", "其他"]
        }
        if(InsuredModel.idType == '护照'){
          if(!PassportNumberReg.test(InsuredModel.idCode)){
            this.$toast.fail("护照号码格式错误");
            return;
          }
        }
        if(InsuredModel.idType == '其他'){
          let idCode = InsuredModel.idCode
          let has= this.isOther(idCode)
          console.log("has1",has)
            if(has){
              console.log("has2",has)
              this.$toast.fail("证件格式错误");
              return;
            }
          // if(!reg_test.test(InsuredModel.idCode)){
          //   this.$toast.fail("证件格式错误");
          //   return;
          // }
        }
        // 被保人手机号验证
        let reg=/^1[3456789]\d{9}$/
        if(InsuredModel.phone && reg.test(InsuredModel.phone * 1)==false){
           Toast.fail('被保人手机号不正确');
           return
        }
        let obj = {
          name: InsuredModel.name,
          pinyin: InsuredModel.pinyin || "",
          idType: InsuredModel.idType,
          idCode: InsuredModel.idCode,
          sex: InsuredModel.sex == "男" ? 1 : 2,
          birthday: this.moment(InsuredModel.birthDayTime).valueOf(),
          phone: InsuredModel.phone,
          // mailbox: InsuredModel.email,
          num: 1,
          currentDate: InsuredModel.currentDate,
        };
        console.log("objj",obj)
        // for(var i = 0; i < this.InsuredList.length; i++){
        //   if(obj.idCode === this.InsuredList[i].idCode){
        //      Toast.fail('证件号重复！');
        //     return ""
        //   }
        // }
        // console.log('验证通过');
        this.InsuredList.push(obj);
        console.log("this.InsuredList", this.InsuredList);
      } else {
        let PassportNumberReg = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/
        let InsuredModel = JSON.parse(JSON.stringify(this.InsuredModel));
        console.log("InsuredModel", InsuredModel);
        if (
          InsuredModel.name == "" ||
          InsuredModel.idType == "" ||
          InsuredModel.idCode == "" ||
          InsuredModel.sex == "" ||
          InsuredModel.birthDayTime == "" ||
          (this.detail.hasPinyin && !InsuredModel.pinyin)
        ) {
          this.$toast.fail("请将被保人信息填写完整");
          return;
        }
        if(InsuredModel.name.length <2){
          this.$toast.fail("被保人姓名不能只有一个字");
          return
        }
        if(InsuredModel.idType == '护照'){
          if(!PassportNumberReg.test(InsuredModel.idCode)){
            this.$toast.fail("被保人护照格式错误");
            return;
          }
        }
        if(InsuredModel.idType == '其他'){
          let idCode = InsuredModel.idCode
          let has= this.isOther(idCode)
            if(has){
              this.$toast.fail("证件格式错误");
              return;
            }
          // if(!PassportNumberReg.test(InsuredModel.idCode)){
          //   this.$toast.fail("证件格式错误");
          //   return;
          // }
        }
        // 被保人手机号验证
        let reg=/^1[3456789]\d{9}$/
        if(InsuredModel.phone && reg.test(InsuredModel.phone * 1)==false){
           Toast.fail('被保人手机号不正确');
           return
        }
        //  for(var i = 0; i < this.InsuredList.length; i++){
        //   if(InsuredModel.idCode === this.InsuredList[i].idCode){
        //      Toast.fail('证件号重复！');
        //      return ""
        //   }
        // }
        // console.log('验证通过');
        // console.log("验证验证身份证号")
        this.InsuredList[this.openInsureIndex] = {
          name: InsuredModel.name,
          pinyin: InsuredModel.pinyin || "",
          idType: InsuredModel.idType,
          idCode: InsuredModel.idCode,
          sex: InsuredModel.sex == "男" ? 1 : 2,
          birthday: this.moment(InsuredModel.birthDayTime).valueOf(),
          phone: InsuredModel.phone,
          // mailbox: InsuredModel.email,
          num: 1,
          currentDate: InsuredModel.currentDate,
        };
      }
      this.price = this.InsuredList.length * this.oneprice;
      this.InsuredFlag = false;
    },
    async init() {
      await this.getDetail();
      if (window.__wxjs_environment === "miniprogram" && !this.$route.query.isCps) {
        wx.miniProgram.postMessage({
          data: {
            title: this.detail.title,
            url:window.location.origin + '/sign?id='  + this.$route.query.id + '&startTime=' + this.$route.query.startTime+ '&plan=' + this.$route.query.plan + '&date=' + this.$route.query.date + '&accountId=' + this.publicData.id + '&isCps=1'
          }
        });
      }
      if (this.detail.hasDestnation) {
        this.step1Data.planAddr = "";
      }
      // v.getTime() > startAge.getTime() || v.getTime() <= endAge.getTime()
      let mixYear =  this.step1Data.startTime.substring(0,4)
      let mixMonth = this.step1Data.startTime.substring(5,7)
      let mixDay = this.step1Data.startTime.substring(8,10)

      this.maxDate =  new Date(mixYear - this.startAge, mixMonth - 1, mixDay)
      let minEnd = new Date(mixYear - this.endAge -1, mixMonth - 1, mixDay)
      // console.log("minEn",minEnd)
      let endAge = minEnd.getTime() + 25 * 60 * 60 * 1000
      // console.log("endAge",endAge)
      let year = this.moment(endAge).format("YYYY")
      let month = this.moment(endAge).format("MM")
      let day = this.moment(endAge).format("DD")
      this.minDate =  new Date(year,month-1,day)
      // console.log(year,month,day,new Date(year,month-1,day))
      // console.log("this.maxDate",this.maxDate)
      // console.log("this.minDate",this.minDate)
      this.currentDate = new Date(mixYear - this.startAge, mixMonth - 1, mixDay)

      // this.maxDate = new Date(new Date().getTime() + 24 * 60 * 60 * 1000);
      // let year = new Date().getFullYear();
      // let minDate = (year - 18) + '-01-01 00:00:00'
      // console.log("year - this.detail.endAge", year - this.detail.endAge);
      // this.minDate = new Date(year - this.detail.endAge, 1, 1);
      // this.minDate = new Date(this.moment((year - this.detail.endAge) + '-01-01 00:00:00').valueOf())
      // this.currentDate = new Date(this.moment(year - 18 + "-01-01 00:00:00").valueOf());
      // alert(666)
      // await this.getTags()
      // await this.getCompanys()
      // await this.getTypes()
      // await this.getProducts()
    },
    onConfirm(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.step1Data.planName = value;
      console.log("this.step1Data.planName",this.step1Data.planName)
      this.step1Data.planIndex = index;
      this.chosePlanFlag = false;
      this.oneprice = this.detail.plans[index].cycle[this.$route.query.date].price;
      console.log("this.oneprice",this.oneprice)
    },
    onChange(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancel() {
      // Toast('取消');
      this.chosePlanFlag = false;
    },
    onConfirmId(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.policyHolder.idType = value;
      this.idTypeFlag = false;
    },
    onChangeId(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancelId() {
      // Toast('取消');
      this.idTypeFlag = false;
    },
    onConfirmSex(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.policyHolder.sex = value;
      this.sexFlag = false;
    },
    onCancelSex() {
      // Toast('取消');
      this.sexFlag = false;
    },
    //被保人
    openInsured(type, data, index) {
      this.openInsureType = type;
      if (type == "add") {
        this.InsuredModel = {
          name: "",
          pinyin: "",
          idType: "身份证",
          idCode: "",
          sex: "男",
          birthDay: "",
          birthDayTime: "",
          phone: "",
          email: "",
          currentDate: "",
        };
        this.InsuredFlag = true;
      } else {
        this.openInsureType = type;
        this.openInsureIndex = index;
        data = JSON.parse(JSON.stringify(data));
        let time = new Date(data.birthDay);
        // console.log(data.birthday);
        this.InsuredModel = {
          name: data.name,
          pinyin: data.pinyin || "",
          idType: data.idType,
          idCode: data.idCode,
          sex: data.sex == 1 ? "男" : "女",
          birthDay: data.birthday
            ? moment(data.birthday).format("YYYY-MM-DD")
            : "",
          birthDayTime: data.birthday,
          phone: data.phone,
          // email: data.mailbox,
          currentDate: data.birthday ? new Date(data.birthday) : "",
        };
        console.log('this.InsuredModel', this.InsuredModel);
        this.InsuredFlag = true;
      }
    },
    onConfirmIdInsured(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.InsuredModel.idType = value;
      this.InsuredIdTypeFlag = false;
    },
    onChangeIdInsured(picker, value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
    },
    onCancelIdInsured() {
      // Toast('取消');
      this.InsuredIdTypeFlag = false;
    },
    onConfirmSexInsured(value, index) {
      // Toast(`当前值：${value}, 当前索引：${index}`);
      this.InsuredModel.sex = value;
      this.InsuredSexFlag = false;
    },
    onCancelSexInsured() {
      // Toast('取消');
      this.InsuredSexFlag = false;
    },
    onConfirmBirth(date) {
      // this.policyHolder.birthDay = date.format('YYYY-MM-DD')
      // this.policyHolder.birthDayTime = new Date(date).getTime()
      // console.log(date.format('YYYY-MM-DD'))
      this.policyHolder.birthDay = moment(date).format("YYYY-MM-DD");
      this.policyHolder.birthDayTime = moment(
        this.policyHolder.birthDay
      ).valueOf();
      // console.log(moment(this.policyHolder.birthDay).valueOf());
      if (!this.policyHolder.birthDay) {
        this.insureError.birthday = true;
        this.$toast("投保人出生日期不能为空");
        return;
      }
      let birthday = this.moment(this.policyHolder.birthDay).format(
        "YYYY-MM-DD"
      );
      let endDate = this.moment(
        this.step1Data.startTime ? this.step1Data.endTime : new Date().getTime()
      ).format("YYYY-MM-DD");
      let age = this.jsGetAge(birthday, endDate);
      if (age < 18) {
        this.insureError.birthday = true;
        this.$toast("投保人年龄不能为小于18岁");
      } else {
        this.insureError.birthday = false;
      }
      this.birthdayFlag = false;
    },
    onConfirmBirthInsured(date) {
      // this.InsuredModel.birthDay = date.format('YYYY-MM-DD')
      // this.InsuredModel.birthDayTime = new Date(date).getTime()
      // console.log(date.format('YYYY-MM-DD'))
      this.InsuredModel.birthDay = moment(date).format("YYYY-MM-DD");
      this.InsuredModel.birthDayTime = moment(
        this.InsuredModel.birthDay
      ).valueOf();
      this.InsuredModel.currentDate = date;
      // console.log(moment(this.InsuredModel.birthDay).valueOf());
      this.InsuredBirthdayFlag = false;
    },
    onCancelBirth() {
      // Toast('取消');
      this.birthdayFlag = false;
    },
    onConfirmCal() {},
    async getDetail() {
      //获取产品信息
      let res = await this.$http.post("api/insuranceProduction/get", {
        id: this.id,
      });
      if (res.code == 0) {
        let detail = res.t;
        if (detail.hasDestnation) {
          try {
            detail.goDestnations = JSON.parse(detail.goDestnations);
          } catch (error) {
            detail.goDestnations = []
          }
          
        }
        detail.plans = JSON.parse(detail.plans);
        detail.files = JSON.parse(detail.files);
        detail.noticeFiles = detail.noticeFiles ? JSON.parse(detail.noticeFiles) : []
        let fileArr = []
        detail.files.forEach((item,index)=>{
          let obj = {
            name:item.name,
            url:item.response.url
          }
          fileArr.push(obj)
        })
        this.detailsFiles1 = fileArr
        let fileArr2 = []
        detail.noticeFiles.forEach((item,index)=>{
          let obj = {
            name:item.name,
            url:item.response.url
          }
          fileArr2.push(obj)
        })
        this.detailsFiles2 = fileArr2
        try {
          detail.summarys = JSON.parse(detail.summarys);
        } catch (error) {}

        this.detail = detail;

        let ageArr = [];
        detail.plans[0].cycle.forEach((el) => {
          ageArr.push({
            start: el.startAge,
            end: el.endAge,
          });
        });

        for (let i = ageArr.length; i > 0; i--) {
          for (let j = i - 1; j > -1; j--) {
            if (JSON.stringify(ageArr[i]) === JSON.stringify(ageArr[j])) {
              ageArr.splice(j, 1);
            }
          }
        }
        this.setAges = ageArr;
        this.step1Data.name = this.detail.title;
        this.step1Data.planName = this.detail.plans[
          this.$route.query.plan
        ].name;
        let endDays = this.detail.plans[this.$route.query.plan].cycle[
          this.$route.query.date
        ].end;
        this.oneprice = this.detail.plans[this.$route.query.plan].cycle[
          this.$route.query.date
        ].price;
        // console.log("endDays", endDays);
        if (detail.todayBuyMin) {
          this.todayBuyMin = (Math.floor(detail.todayBuyMin / 60) + "小时" + (detail.todayBuyMin % 60) + "分");
        }else{
          this.todayBuyMin = 0
        }
        let startDate = moment(this.$route.query.startTime).valueOf();
        let endTime = moment(moment(this.step1Data.startTime).valueOf() + 86400000 * endDays
        ).format("YYYY-MM-DD HH:mm:ss");
        if (startDate <= new Date().getTime()) {
          let todayBuyMin = 3600000;
          if (this.detail.todayBuyMin) {
            todayBuyMin = this.detail.todayBuyMin * 60 * 1000;
          }
          this.step1Data.startTime = new Date().getTime() + todayBuyMin;
          this.step1Data.endTime =
            this.step1Data.startTime + (86400000 * endDays - 1000);
        } else {
          this.step1Data.startTime = moment(
            this.$route.query.startTime
          ).valueOf();
          this.step1Data.endTime =
            this.step1Data.startTime + (86400000 * endDays - 1000);
        }
        try {
          this.detail.serviceFiles = JSON.parse(this.detail.serviceFiles);
        } catch (error) {}
        try {
          this.detail.customerFiles = JSON.parse(this.detail.customerFiles);
        } catch (error) {}

        if (this.detail.noticePdf) {
          try {
            this.detail.noticePdf = JSON.parse(this.detail.noticePdf);
            if (this.detail.noticePdf.length) {
              this.noticePdfFlag = true;
              // this.abledBut = true
              // this.timer1()
            }
          } catch (error) {}
        }
        this.step1Data.startTime = moment(this.step1Data.startTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.step1Data.endTime = moment(this.step1Data.endTime).format(
          "YYYY-MM-DD HH:mm:ss"
        );
        this.calculateStartTime = moment(this.step1Data.startTime).valueOf();
        this.calculateEndTime =
          moment(this.step1Data.startTime).valueOf() + 86400000 * (endDays - 1);
        // console.log(
        //   moment(this.step1Data.startTime).valueOf() + 86400000 * endDays
        // );
        this.detail.plans.forEach((item, index) => {
          this.plans.push(item.name);
        });

        // this.step1Data.planAge =
        //   this.detail.fromAge + "周岁" + "-" + detail.endAge + "周岁";
      this.step1Data.planAge = this.startAge + "周岁" + "-" + this.endAge + "周岁"
        document.title = this.detail.title + "报名";
      } else {
        this.$toast.fail(res.msg);
      }

      // console.log(res);
    },
    async getTags() {
      let res = await this.$http.post("api/insuranceProduction/getTags", {});
      console.log("标签", res);
      if (res.code == 0) {
        try {
          res.t.unshift("不限");
          this.tagList = res.t;
        } catch (error) {
          this.tagList = [];
        }
      } else {
        this.$toast.fail(res.msg);
      }
    },
    async getTypes() {
      let res = await this.$http.post(
        "api/insuranceComponay/getClassifies",
        {}
      );
      console.log("分类", res);
      if (res.code == 0) {
        try {
          this.typeList = JSON.parse(res.t);
          let level2 = [];
          this.typeList.forEach((item, index) => {
            if (item.children.length) {
              item.children.forEach((el, i) => {
                level2.push(el);
              });
            }
          });
          level2.unshift({
            id: "",
            level: 2,
            name: "全部",
          });
          this.level2Types = level2;
        } catch (error) {
          this.typeList = [];
        }
        // console.log(this.typeList);
      } else {
        this.$toast.fail(res.msg);
      }
    },
    async getProducts() {
      this.params.accountId = this.publicData.id;
      let res = await this.$http.post(
        "api/insuranceProduction/getList",
        this.params
      );
      console.log("产品", res);
      res.list.forEach((el) => {
        el.planIndex = 0;
        try {
          el.summarys = JSON.parse(el.summarys);
          el.plans = JSON.parse(el.plans);
        } catch (error) {
          el.plans = [];
          el.summarys = [];
        }
      });
      this.products = res;
    },
    async getCompanys() {
      let res = await this.$http.post("api/insuranceComponay/getList", {
        queryKey: "",
        pageNumber: 1,
        pageSize: 10,
      });
      console.log("公司", res);
      res.list.unshift({
        name: "不限",
      });
      let companys = [];
      res.list.forEach((item, index) => {
        let obj = {
          value: !!item.id ? item.id : "",
          text: "公司:" + item.name,
        };
        companys.push(obj);
      });
      this.companys = companys;
    },
    jsGetAge(strBirthday,edtTime) {
      // strBirthday = "1934-09-17"
      var returnAge;
      var birthYear = strBirthday.slice(0, 4);
      var birthMonth = strBirthday.slice(5, 7);
      var birthDay = strBirthday.slice(8);
      // let d = new Date();
      // var nowYear = d.getFullYear();
      // var nowMonth = d.getMonth() + 1;
      // var nowDay = d.getDate();
      // let age = nowYear - birthYear - (nowMonth < birthMonth || (nowMonth == birthMonth && nowDay < birthDay) ? 1 : 0);
      var d = edtTime;
      var nowYear = d.slice(0, 4);
      var nowMonth = d.slice(5, 7);
      var nowDay = d.slice(8);
      let age = nowYear - birthYear - (nowMonth < birthMonth || (nowMonth == birthMonth && nowDay < birthDay) ? 1 : 0);
      console.log("agegege",age)
      // var d = edtTime;
      // console.log("edtTime",d)
      // var nowYear = d.slice(0, 4);
      // var nowMonth = d.slice(5, 7);
      // var nowDay = d.slice(8);
      // if (nowYear == birthYear) {
      //   returnAge = 0; //同年 则为0岁
      // } else {
      //   var ageDiff = nowYear - birthYear; //年之差
      //   if (ageDiff > 0) {
      //     if (nowDay - birthDay >= 0) {
      //       if (nowMonth - birthMonth >= 0) {
      //         returnAge = ageDiff + 1;
      //       } else {
      //         returnAge = ageDiff;
      //       }
      //     } else {
      //       nowMonth = nowMonth - 1;
      //       if (nowMonth - birthMonth >= 0) {
      //         returnAge = ageDiff + 1;
      //       } else {
      //         returnAge = ageDiff;
      //       }
      //     }
      //   } else {
      //     returnAge = -1; //返回-1 表示出生日期输入错误 晚于今天
      //   }
      // }
      // console.log("returnAge")
       return age; //返回周岁年龄
    },
    isOther(idCode){
      let newReg = new RegExp("[\\u4E00-\\u9FFF]+","g")
      let regs = /^[a-zA-Z]+$/
      let other = new RegExp("[A-Za-z0-9]","g") //只需包含数字和英文
      let hasErr = true
      if(idCode.length>=5 && idCode.length<=20){
          if(!newReg.test(idCode)){
            console.log(other.test(idCode))
            console.log(!regs.test(idCode))
            if(other.test(idCode) && !regs.test(idCode)){
              hasErr = false
            }
          }
      }
      if(hasErr){
          // this.step1Data.insurePeople[type].errMsg = "证件格式错误";
          return true
      }else{
        return false
          // this.step1Data.insurePeople[type].errMsg = "";
      }
    },
    trim(strs) {
      return strs.replace(/(^\s*)|(\s*$)/g, ""); //使用js正则表达式方法
    },
    // 选择投保时间
    showDatePicker(picker) { //弹出层并显示时间选择器
            this.isPopShow = true;
            this.datePicker = picker;
    },
    cancelPicker() { // 选择器取消按钮点击事件
            this.isPopShow = false;
            this.datePicker = "";
    },
    confirmPicker(value) {// 确定按钮，时间格式化并显示在页面上
            var date = value;
            let year = date.getFullYear()
            var month = date.getMonth() + 1;
            var day = date.getDate();
            let hour = date.getHours()
            let minute = date.getMinutes()
            let second = date.getSeconds()
            if (month >= 1 && month <= 9) {month = `0${month}`}
            if (day >= 0 && day <= 9) {day = `0${day}`}
            if (hour >= 0 && hour <= 9) { hour = `0${hour}` }
            if (minute >= 0 && minute <= 9) { minute = `0${minute}` }
            if (second >= 0 && second <= 9) { second = `0${second}` }
            var timer = year + "-" + month + "-" + day + " " + hour + ":" + minute + ":" + second 
            this.$refs[this.datePicker].innerHTML = timer;
            this.isPopShow = false;
            this.datePicker = "";
          //   let timerDate = that.moment(
          //   that.startTime
          //     ? that.endTime
          //     : new Date().getTime()
          // ).format("YYYY-MM-DD");
    },
    formatter(type, value) {// 格式化选择器日期
            if (type === "year") {
                return `${value}年`;
            } else if (type === "month") {
                return `${value}月`;
            }else if (type === 'day') {
              return `${value}日`;
           }else if (type === 'hour') {

            return `${value}时`

          } else if (type === 'minute') {

            return `${value}分`

          } else if (type === 'second') {

            return `${value}秒`

          }
            return value;
    },
    repeatId(item, list) {
      console.log("item",item)
      console.log("list",list)
        const { idCode } = item;
        if(!!idCode){
          for(var i = 1; i < list.length; i++){
            if(idCode === list[i].idCode) return true;
          }
          return false;
        }else{
          return true;
        }
    }
  },
  filters: {
     checkIdName(val) {
       console.log("nameval",val)
      if(val.length<2){
          return `<span style="color:red;font-size:12px;padding-left:8px">姓名填写不完整</span>`;
      }
       let regs = /^([\u4e00-\u9fa5]+|([a-zA-Z]+\s?)+)$/
      if(!regs.test(val)){
        return `<span style="color:red;font-size:12px;padding-left:8px">姓名格式不正确</span>`;
      }
    },
     checkIdCode(val,type,that) {
      // console.log("that",that);
      console.log("type",type)
      if(val){
          console.log("valalal",val)
          let codes = that.InsuredList.map(v=> (v.idCode))
          console.log('codes :>> ', codes);
          if((that.InsuredList.filter(v => v.idCode == val).length > 1) && codes.includes(val)){
            return `<span style="color:red;font-size:12px">${val}证件号重复</span>`;
          }
          let PassportNumberReg = /(^[A-Za-z0-9]{5,9}$)|^1[45][0-9]{7}$|(^[P|p|S|s]\d{7}$)|(^[S|s|G|g|E|e]\d{8}$)|(^[Gg|Tt|Ss|Ll|Qq|Dd|Aa|Ff]\d{8}$)|(^[H|h|M|m]\d{8,10}$)/
          if(type=="身份证"){
              if (util.isCardID(val)) {
              return val;
              }else {
                return `<span style="color:red;font-size:12px">${val}证件号有误</span>`;
              }
          }
          if(type=="护照"){
            if(PassportNumberReg.test(val)){
              return val
            }else {
              return `<span style="color:red;font-size:12px">${val}护照号码格式错误</span>`;
            }
          }
          if(type=="其他"){
            let newReg = new RegExp("[\\u4E00-\\u9FFF]+","g")
            let regs = /^[a-zA-Z]+$/
            let other = new RegExp("[A-Za-z0-9]","g") //只需包含数字和英文
            let hasErr = true
            if(val.length>=5 && val.length<=20){
                if(!newReg.test(val)){
                  console.log(other.test(val))
                  console.log(!regs.test(val))
                  if(other.test(val) && !regs.test(val)){
                    hasErr = false
                  }
                }
            }
            if(hasErr){
                // this.step1Data.insurePeople[type].errMsg = "证件格式错误";
                // return true
                return `<span style="color:red;font-size:12px">${val}证件格式错误</span>`;
            }else{
              return val
                // this.step1Data.insurePeople[type].errMsg = "";
            }
          //   if(reg_test.test(val)){
          //   return val
          // } else {
          //   return `<span style="color:red;font-size:12px">${val}证件格式错误</span>`;
          // }
          }
          // if (util.isCardID(val)) {
          //   return val;
          // }else if(PassportNumberReg.test(val)){
          //   return val
          // } else {
          //   return `<span style="color:red;font-size:12px">${val}证件号有误</span>`;
          // }
      }
    },
    checkBirthday(val, that) {
      console.log("that",that)
      // console.log("that",that);
      if (val) {
        //验证被保人年龄是否在保障期限内
        let birthday = that.moment(val).format("YYYY-MM-DD");
        let endDate = that.moment(that.step1Data.startTime).format("YYYY-MM-DD");
        let age = that.jsGetAge(birthday,endDate);
        console.log("被保人age", age);
        // if (age > that.detail.endAge || age < that.detail.fromAge) {
        if (age > that.endAge || age < that.startAge) {
          return `<span style="color:red;font-size:12px">${
            that.moment(val).format("YYYY-MM-DD") + "被保人年龄需在承保年龄内"
          }</span>`;
        } else {
          return that.moment(val).format("YYYY-MM-DD");
        }
      } else {
        return `<span style="color:red;font-size:12px">请选择出生日期</span>`;
      }
    },
  },
};
</script>
<style>
.van-swipe-cell__left, .van-swipe-cell__right {
    position: absolute;
    top: 0;
    height: 100%;
    display: flex;
}
</style>
<style lang="scss" scoped>
.copy_text {
  textarea {
    font-size: 12px;
  }
}
.noticePdf {
  .title {
    font-size: 16px;
    font-weight: 700;
    color: #000;
    text-align: center;
    margin-top: 20px;
  }
  p {
    line-height: 25px;
    font-size: 13px;
    span {
      color: #00a971;
      cursor: pointer;
      font-weight: 500;
    }
    &.in {
      text-indent: 20px;
    }
    &.huang {
      color: #f8ad00;
    }
  }
}
.isReady_content {
  max-height: 430px;
  overflow-y: scroll;
  -webkit-overflow-scrolling: touch;
  padding: 15px 10px;
  box-sizing: border-box;
  width: 100%;
  .content {
    width: 100%;
    font-size: 12px;
  }
}
.sign {
  padding: 15px;
  box-sizing: border-box;
  padding-bottom: 130px;
  box-sizing: border-box;

  .px1bar {
    width: 2px;
    height: 12px;
    background: #00d385;
  }
  .bar10px {
    height: 6px;
    background: rgba(244, 244, 244, 1);
    width: 100%;
  }

  .step1 {
    .info {
      padding-bottom: 10px;
      box-sizing: border-box;
      .title {
        display: flex;
        align-items: center;
        .text {
          font-size: 16px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(51, 51, 51, 1);
          padding-left: 4px;
          box-sizing: border-box;
        }
      }
      .inp-box {
        .item {
          display: flex;
          font-size: 14px;
          .label {
            width: 90px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-start;
          }
        }
      }
      .add-box {
        text-align: center;
        font-size: 0.26rem;
        color: #2e2d2d;
        line-height: 0.4rem;
        font-weight: 700;
        padding: 0.25rem 0 0.25rem;
        // border-top: 1px solid #f1f1f1;
        .add-link {
          width: 2rem;
          margin: 0 auto;
          display: flex;
          justify-content: center;
          align-items: center;
          img {
            width: 15px;
            margin-right: 5px;
          }
        }
      }
      .import-name {
        width: 100%;
        height: 50px;
        display: flex;
        justify-content: center;
        align-items: center;
        .btn {
          width: 3.45rem;
          height: 0.35rem;
          background: linear-gradient(125deg, #2ada78 0%, #62db9e 100%);
          border-radius: 0rem;
          font-size: 0.13rem;
          font-family: PingFang SC;
          font-weight: 500;
          color: #ffffff;
          display: flex;
          justify-content: center;
          align-items: center;
          border-radius: 5px;
        }
      }
      .people-list {
        width: 100%;
        .people-item {
          display: flex;
          border-bottom: 1px solid #f1f1f1;
          padding: 10px 0;
          box-sizing: border-box;
          .right {
            width: 100px;
            flex-shrink: 0;
            display: flex;
            justify-content: flex-end;
            font-size: 0.15rem;
            align-items: center;
            position: relative;
            .del {
              position: absolute;
              right: 0;
              top: 0;
              z-index: 1000;
              display: flex;
              justify-content: center;
              align-items: center;
            }
          }
          .left {
            flex: 1;
            .name {
              font-size: 0.15rem;
              font-weight: 700;
              color: #333;
            }
            .tip {
              font-size: 0.12rem;
              color: #848484;
              line-height: 0.15rem;
              margin-top: 0.09rem;
              display: flex;
              .idtype {
                margin-right: 8px;
              }
            }
          }
        }
      }
    }
  }

  .step2 {
    .titel {
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 211, 133, 1);
      height: 40px;
      line-height: 40px;
    }
    .collapse-item {
      .item-content {
        .limargin {
          margin-bottom: 15px;
        }
        .item {
          display: flex;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(102, 102, 102, 1);
          .label {
            width: 0.8rem;
            flex-shrink: 0;
          }
          .text {
            flex: 1;
            color: #333333;
            .summary-info {
              width: 100%;
              padding-top: 5px;
              box-sizing: border-box;
              // ul{
              li {
                display: flex;
                .price {
                  width: 80px;
                  flex-shrink: 0;
                }
                .name {
                  flex: 1;
                }
              }
              // }
            }
          }
        }
      }
    }
  }

  .Insurededit {
    .btns {
      height: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      .btn {
        width: 250px;
        height: 45px;
        border-radius: 45px;
        background: #00d385;
        color: #fff;
        display: flex;
        justify-content: center;
        align-items: center;
        font-size: 16px;
      }
    }
  }

  .tipcheck {
    position: fixed;
    bottom: 50px;
    width: 100%;
    display: flex;
    z-index: 1000;
    background: rgba(255, 255, 255, 1);
    left: 0;
    right: 0;
    height: 80px;
    padding: 0 10px;
    box-sizing: border-box;
    font-size: 12px;
    flex-direction: column;
    justify-content: center;
    .van-checkbox {
      margin: 5px 0;
      overflow: inherit;
    }
    .text {
      font-size: 0.1rem;
      color: #000;
      line-height: 1.4;
      b {
        color: #fb4a41;
        font-weight: 400;
      }
    }
  }

  .foot-btn {
    height: 50px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px -1px 8px 3px rgba(0, 0, 0, 0.04);
    position: fixed;
    bottom: 0;
    width: 100%;
    display: flex;
    z-index: 1000;
    left: 0;
    .left {
      width: 100px;
      flex-shrink: 0;
      font-size: 10px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(0, 211, 133, 1);
      background: #fff;
      display: flex;
      justify-content: center;
      align-items: center;
      box-sizing: border-box;
      position: relative;
      &:after {
        content: " ";
        position: absolute;
        top: 0;
        width: 1px;
        bottom: 0;
        color: #c7c7c7;
        right: 0;
        border-right: 1px solid #c7c7c7;
        transform: scaleX(0.5);
        height: 60%;
        top: 50%;
        transform: translateY(-50%);
      }
      a {
        img {
          width: 25px;
          height: 25px;
        }
      }
    }
    .price {
      color: #ff4e33;
      font-weight: 700;
      font-size: 18px;
      width: 100px;
      display: flex;
      justify-content: center;
      align-items: center;
      font-family: PingFangSC-Medium, PingFang SC;
    }
    .right {
      flex: 1;
      background: rgba(0, 211, 133, 1);
      font-size: 16px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 700;
      color: rgba(255, 255, 255, 1);
      display: flex;
      justify-content: center;
      align-items: center;
      // font-weight: 500;
    }
  }
}
</style>

<style lang="scss">
// .van-overlay{
//   z-index:9999!important
// }
// .van-popup{
//   z-index:10000!important
// }
.sign {
  width: 100%;
  overflow-x: hidden;
  .tipcheck {
    .van-checkbox__icon {
      margin-right: 40px;
    }
    .van-checkbox__label {
      margin-left: 0px;
    }
  }

  .t_red {
    color: red;
  }
  .sign-step {
    .van-steps--horizontal {
      padding: 0;
    }
    .van-steps--horizontal .van-steps__items {
      margin: 0;
    }
  }
  .van-field__value {
    font-size: 13px;
  }
  .van-field__label {
    font-size: 12px;
    font-weight: 600;
    span {
      font-size: 12px;
    }
  }
  .step1 {
    .info {
      .van-cell {
        padding-left: 0;
        padding-right: 0;
        padding: 2px 0px;
      }
      .insurepeopel_box {
        //  padding-left: 16px;
        .van-cell {
          padding-left: 6px;
        }
        .van-cell--required::before {
          left: 0px;
          top: 50%;
          transform: translateY(-50%);
        }
        .error {
          border: 1px solid red;
          box-sizing: border-box;
        }
      }
      .title {
        height: 35px;
        line-height: 35px;
      }
      .inp-box {
        .item {
          .van-field__label {
            font-size: 13px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 600;
            color: rgba(51, 51, 51, 1);
          }
          .van-field__body {
            border-bottom: 1px solid #f1f1f1;
          }
        }
      }
    }
  }

  .step2 {
    .data-list {
      .van-cell {
        padding: 0;
      }
      .van-hairline--top-bottom::after {
        border-width: 0;
      }
      .van-collapse-item__title--expanded::after {
        display: none;
      }
      .van-cell__title {
        height: 30px;
        line-height: 30px;
      }
      .van-collapse-item__content {
        padding: 0;
      }
      .item-name {
        align-items: center;
        font-size: 16px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(51, 51, 51, 1);
        .px1bar {
          margin-right: 10px;
        }
      }
    }
  }

  .Insurededit {
    .item .van-field__body {
      border-bottom: 1px solid #f1f1f1;
    }
  }
}
.slectName-pop {
  width: 100%;
  height: 100%;
  background: #fff;
  // margin-top: 45px;
  .top-banner {
    height: 45px;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid #9999;
    box-sizing: border-box;
    .check {
      width: 100px;
      flex-shrink: 0;
    }
    .title {
      font-size: 16px;
      color: #000;
      // margin-left: 30px;
      flex: 1;
    }
  }
  .namelist-box {
    padding: 16px;
    box-sizing: border-box;
    padding-top: 0;
    .name-list {
      .name-item {
        border-bottom: 1px solid #9999;
        height: 40px;
        width: 100%;
        display: flex;
        align-items: center;
        box-sizing: border-box;
        .check {
          width: 50px;
          flex-shrink: 0;
        }
        .title {
          font-size: 14px;
          color: #000;
          // margin-left: 30px;
        }
      }
    }
  }
  // .selectChoose{
  //   padding-bottom:50px;
  // }
  .import-btn {
    position: fixed;
    bottom: 0;
    height: 45px;
    background: blue;
    left: 0;
    right: 0;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }
}
</style>
